'use client'
import {
  MONTH_DIVISIONS,
  TIMELINE_MONTHS
} from "./chunk-GVJNMZ3E.mjs";
import {
  useTimeline_default
} from "./chunk-ZYYXDCUC.mjs";
import {
  Context
} from "./chunk-4NAR6N5F.mjs";
import {
  useGetTagsTotalEvents
} from "./chunk-IHQWHDA5.mjs";
import {
  DEFAULT_PAGINATION
} from "./chunk-EVAX4C7B.mjs";
import {
  Filters_default
} from "./chunk-UDXU34ZZ.mjs";
import {
  Info_default,
  ListItem_default,
  provider_default,
  provider_default2
} from "./chunk-7KKOELSM.mjs";
import {
  useSearch
} from "./chunk-WOKBAUXU.mjs";
import {
  ContentfulSection_default,
  EventCarousel_default,
  EventLoading_default,
  Grid_default,
  Item_default,
  Link_default,
  MonthlyListPlaceholder_default,
  monthly_default
} from "./chunk-D3RK6H2X.mjs";
import {
  Price_default,
  Sellers_default
} from "./chunk-3RIFEIGI.mjs";
import {
  useConfig_default
} from "./chunk-ZSKGVFZ4.mjs";
import {
  ThemeButton_default
} from "./chunk-VYWHMVWT.mjs";
import {
  CollapsableText_default
} from "./chunk-TAYU5GTT.mjs";
import {
  DecoratedSection_default,
  FindMore_default
} from "./chunk-THREBTTP.mjs";
import {
  ContentfulMedia_default
} from "./chunk-IOBZ5NBW.mjs";
import {
  useFavorites
} from "./chunk-BB4H5TUC.mjs";
import {
  useItinerary
} from "./chunk-YBJOQHTL.mjs";
import {
  useCalendarQuery_default
} from "./chunk-PLJBED27.mjs";
import {
  useFilterQuery_default
} from "./chunk-7GAGCG6W.mjs";
import {
  useFilterState
} from "./chunk-TOSXVIFC.mjs";
import {
  useGetWeatherCondition
} from "./chunk-F7HCPT4F.mjs";
import {
  useGetEventsList
} from "./chunk-TW33R6V4.mjs";
import {
  useGetRangeEvents
} from "./chunk-6SSU4LIJ.mjs";
import {
  useGetYearlyEvents
} from "./chunk-RHC47SEZ.mjs";
import {
  useGetCategoryDetail
} from "./chunk-Q6ZXP5B5.mjs";
import {
  useGetCategories
} from "./chunk-HKGNX5TB.mjs";
import {
  __async,
  __objRest,
  __spreadProps,
  __spreadValues
} from "./chunk-BTG5EALA.mjs";

// src/pages/calendar/index.tsx
import { useRouter as useRouter8, useTranslation as useTranslation5 } from "@wbk/config";

// src/components/calendar/EventsCalendar.tsx
import { useRouter as useRouter4 } from "@wbk/config";

// src/components/calendar/yearly/index.tsx
import { useRouter, useTranslation } from "@wbk/config";
import { Button, Paper, Typography } from "@wbk/ui";
import { formatDate, scrollIntoElementId } from "@wbk/utils";

// src/components/ui/Loading/YearlyCalendarPlaceholder.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var YearlyCalendarPlaceholder = () => {
  const length = 12;
  return /* @__PURE__ */ jsx("div", { className: "container grid grid-cols-1 gap-12 py-10 sm:grid-cols-2 lg:grid-cols-3", children: Array.from({ length: 8 }, (_, index) => /* @__PURE__ */ jsxs("div", { children: [
    /* @__PURE__ */ jsx("div", { className: "grid grid-cols-4 items-center justify-center gap-1 sm:gap-2", children: Array.from({ length }, (_2, i) => {
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: "aspect-1 bg-body-level-2 shrink-0 animate-pulse rounded-md"
        },
        i
      );
    }) }),
    /* @__PURE__ */ jsxs("div", { className: "mt-4 flex items-center justify-between gap-2", children: [
      /* @__PURE__ */ jsx("div", { className: "bg-body-level-2 h-7 w-24 animate-pulse rounded-md" }),
      /* @__PURE__ */ jsx("div", { className: "bg-body-level-2 h-7 w-14 animate-pulse rounded-md" })
    ] })
  ] }, `yearly-calendar-placeholder-${index}`)) });
};
var YearlyCalendarPlaceholder_default = YearlyCalendarPlaceholder;

// src/components/calendar/yearly/index.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var LIMIT = 12;
var YearlyCalendar = () => {
  const { t } = useTranslation("calendar_common");
  const { locale } = useRouter();
  const { months, selectMonth, year } = useCalendarQuery_default();
  const { data, isLoading } = useGetYearlyEvents({
    lang: locale,
    limit: LIMIT
  });
  if (isLoading) {
    return /* @__PURE__ */ jsx2(YearlyCalendarPlaceholder_default, {});
  }
  return /* @__PURE__ */ jsx2("div", { className: "container grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-3", children: Object.keys(months).map((month) => {
    const list = data == null ? void 0 : data[month];
    const items = (list == null ? void 0 : list.items) || [];
    const total = (list == null ? void 0 : list.total) || 0;
    const empty = total <= 0;
    const monthIndex = months[month];
    const monthName = formatDate(new Date(year, monthIndex), locale, { month: "long" });
    return /* @__PURE__ */ jsx2(Paper, { className: "!p-0", children: /* @__PURE__ */ jsxs2(
      Button,
      {
        shape: "text",
        className: "text-text block w-full !p-2",
        onClick: () => {
          selectMonth(month);
          scrollIntoElementId("calendar-section");
        },
        children: [
          empty ? /* @__PURE__ */ jsxs2("div", { className: "relative grid grid-cols-4 items-center justify-center gap-1 sm:gap-2", children: [
            /* @__PURE__ */ jsxs2("div", { className: "absolute inset-0 flex flex-col items-center justify-center space-y-2 px-10 py-5 text-center", children: [
              /* @__PURE__ */ jsx2(Typography, { variant: "label-XS", strong: true, children: t("calendar_common:event_calendar.there_are_no_events") }),
              /* @__PURE__ */ jsx2(Typography, { variant: "label-XS", children: t("calendar_common:event_calendar.no_events_added_for_this_month") })
            ] }),
            Array.from({ length: LIMIT }, (_, i) => {
              return /* @__PURE__ */ jsx2("div", { className: "aspect-1 shrink-0 rounded-md bg-transparent" }, i);
            })
          ] }) : /* @__PURE__ */ jsxs2("div", { className: "grid grid-cols-4 items-center justify-center gap-1 sm:gap-2", children: [
            items.map((event, i) => /* @__PURE__ */ jsxs2("div", { className: "relative overflow-hidden rounded-md", children: [
              /* @__PURE__ */ jsx2("div", { className: "shrink-0", children: /* @__PURE__ */ jsx2(
                ContentfulMedia_default,
                {
                  media: event.image11,
                  width: 400,
                  height: 400,
                  fit: "thumb",
                  ratio: "1x1",
                  placeholder: true,
                  className: "aspect-1 object-cover"
                }
              ) }),
              total > LIMIT && i === items.length - 1 && /* @__PURE__ */ jsx2("div", { className: "bg-body-dark/70 absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ jsxs2(Typography, { variant: "label-XS", className: "text-body-light", children: [
                total - LIMIT,
                " ",
                t("calendar_common:event_calendar.others")
              ] }) })
            ] }, event.id)),
            total < LIMIT && Array.from({ length: LIMIT - total }, (_, i) => {
              return /* @__PURE__ */ jsx2(
                "div",
                {
                  className: "aspect-1 bg-body-level-3 shrink-0 rounded-md"
                },
                `placeholder-${i}`
              );
            })
          ] }),
          /* @__PURE__ */ jsxs2("div", { className: "mt-4 flex items-center justify-between gap-2", children: [
            /* @__PURE__ */ jsx2(Typography, { variant: "label-L", strong: true, children: monthName }),
            total > 0 && /* @__PURE__ */ jsx2(Typography, { variant: "label-S", children: t("calendar_common:events.events_total", { count: total }) })
          ] })
        ]
      }
    ) }, month);
  }) });
};
var yearly_default = YearlyCalendar;

// src/components/calendar/CalendarHeader.tsx
import { useRouter as useRouter2, useTranslation as useTranslation2 } from "@wbk/config";
import { twMerge } from "tailwind-merge";
import { Button as Button2, Carousel, ToggleGroup, Typography as Typography2 } from "@wbk/ui";
import { formatDate as formatDate2, scrollIntoElementId as scrollIntoElementId2 } from "@wbk/utils";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var CalendarHeader = ({ mode, changeMode }) => {
  const { t } = useTranslation2("calendar_common");
  const { search, locale } = useRouter2();
  const { months, month, selectMonth, year } = useCalendarQuery_default();
  const isYear = search.get("mode") === "yearly";
  const title = t("calendar_common:event_calendar.title");
  return /* @__PURE__ */ jsxs3("div", { className: "bg-body sticky top-0 z-20 pt-6", children: [
    /* @__PURE__ */ jsxs3("div", { className: "container flex flex-col gap-2 md:flex-row md:items-center md:justify-between", children: [
      /* @__PURE__ */ jsx3(Typography2, { variant: "heading-XXL", children: title }),
      /* @__PURE__ */ jsxs3("div", { className: "flex flex-wrap justify-between gap-2 md:justify-start", children: [
        /* @__PURE__ */ jsx3(
          ToggleGroup,
          {
            type: "single",
            variant: "stacked",
            value: mode,
            onChange: (value) => {
              if (value) {
                changeMode(value);
                scrollIntoElementId2("calendar-section");
              }
            },
            options: [
              {
                text: t("calendar_common:event_calendar.year"),
                value: "yearly"
              },
              {
                text: t("calendar_common:event_calendar.month"),
                value: "grid"
              },
              {
                text: t("calendar_common:event_calendar.day"),
                value: "list"
              }
            ],
            groupClassName: "!bg-body-level-2 !rounded-M",
            className: "px-M rounded-lg md:px-6",
            activeBtnProps: { shape: "solid", theme: "black", shadow: "S" },
            btnProps: {
              shape: "solid",
              theme: "black",
              className: "opacity-50 hover:opacity-100 bg-transparent"
            }
          }
        ),
        !isYear && /* @__PURE__ */ jsx3(Filters_default, {})
      ] })
    ] }),
    /* @__PURE__ */ jsx3("div", { className: "border-paper bg-body border-b pt-5", children: !isYear && /* @__PURE__ */ jsx3(Carousel, { containerClassName: "flex container justify-evenly", children: Object.keys(months).map((mo) => {
      const active = month === mo;
      const monthIndex = months[mo];
      const monthName = formatDate2(new Date(year, monthIndex), locale, { month: "long" });
      return /* @__PURE__ */ jsx3(
        Button2,
        {
          shape: "text",
          className: twMerge(
            "text-text/50 shrink-0 overflow-visible rounded-none border-b-2 border-transparent",
            active && "text-primary border-primary"
          ),
          onClick: () => {
            selectMonth(mo);
            scrollIntoElementId2("calendar-section");
          },
          children: monthName
        },
        mo
      );
    }) }) })
  ] });
};
var CalendarHeader_default = CalendarHeader;

// src/components/calendar/CalendarFooter.tsx
import { useRouter as useRouter3, useTranslation as useTranslation3 } from "@wbk/config";
import { Button as Button3, Typography as Typography3 } from "@wbk/ui";
import { ArrowIcon } from "@wbk/svg";
import { formatDate as formatDate3, scrollIntoElementId as scrollIntoElementId3 } from "@wbk/utils";
import { jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var CalendarFooter = () => {
  const { locale } = useRouter3();
  const { t } = useTranslation3("calendar_common");
  const { monthIndex, months, selectMonth, year } = useCalendarQuery_default();
  const prevMonthIndex = monthIndex > 0 ? monthIndex - 1 : null;
  const nextMonthIndex = monthIndex < 11 ? monthIndex + 1 : null;
  const prevMonth = prevMonthIndex !== null ? Object.keys(months).find((key) => months[key] === prevMonthIndex) : null;
  const nextMonth = nextMonthIndex !== null ? Object.keys(months).find((key) => months[key] === nextMonthIndex) : null;
  const prevMonthName = prevMonthIndex !== null && !isNaN(prevMonthIndex) && formatDate3(new Date(year, prevMonthIndex), locale, { month: "long" }) || "";
  const nextMonthName = nextMonthIndex !== null && !isNaN(nextMonthIndex) && formatDate3(new Date(year, nextMonthIndex), locale, { month: "long" }) || "";
  const handleClick = (month) => {
    selectMonth(month);
    scrollIntoElementId3("calendar-section");
  };
  return /* @__PURE__ */ jsxs4("div", { className: "border-paper container flex justify-between gap-2 border-t py-10 md:items-center", children: [
    /* @__PURE__ */ jsx4("div", { className: "min-h-2 flex-1 text-start", children: prevMonth && /* @__PURE__ */ jsxs4(Button3, { shape: "text", className: "text-text p-0", onClick: () => handleClick(prevMonth), children: [
      /* @__PURE__ */ jsx4(ArrowIcon, { className: "rtl:rotate-180" }),
      /* @__PURE__ */ jsx4(Typography3, { strong: true, children: t("calendar_common:event_calendar.events_month", { month: prevMonthName }) })
    ] }) }),
    /* @__PURE__ */ jsx4("div", { className: "min-h-2 flex-1 text-end", children: nextMonth && /* @__PURE__ */ jsxs4(Button3, { shape: "text", className: "text-text p-0", onClick: () => handleClick(nextMonth), children: [
      /* @__PURE__ */ jsx4(Typography3, { strong: true, children: t("calendar_common:event_calendar.events_month", { month: nextMonthName }) }),
      /* @__PURE__ */ jsx4(ArrowIcon, { className: "ltr:rotate-180" })
    ] }) })
  ] });
};
var CalendarFooter_default = CalendarFooter;

// src/components/calendar/EventsCalendar.tsx
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var EventsCalendar = () => {
  const { search, setSearch } = useRouter4();
  const mode = search.get("mode") || "grid";
  const isYear = search.get("mode") === "yearly";
  const changeMode = (newMode) => {
    if (mode === newMode)
      return;
    setSearch({ mode: newMode }, { replace: true });
  };
  return /* @__PURE__ */ jsxs5("section", { id: "calendar-section", children: [
    /* @__PURE__ */ jsx5(CalendarHeader_default, { mode, changeMode }),
    /* @__PURE__ */ jsx5("div", { className: "py-10", children: mode === "yearly" ? /* @__PURE__ */ jsx5(yearly_default, {}) : /* @__PURE__ */ jsx5(monthly_default, { displayAs: mode }) }),
    !isYear && /* @__PURE__ */ jsx5(CalendarFooter_default, {})
  ] });
};
var EventsCalendar_default = EventsCalendar;

// src/components/calendar/FeaturedSection.tsx
import { useRouter as useRouter7, useTranslation as useTranslation4 } from "@wbk/config";
import { Carousel as Carousel2, Typography as Typography5 } from "@wbk/ui";

// src/components/category/MoreCategories.tsx
import { twMerge as twMerge2 } from "tailwind-merge";
import { useRouter as useRouter5 } from "@wbk/config";
import { jsx as jsx6 } from "react/jsx-runtime";
var MoreCategories = ({ currentSlug, className, root = true }) => {
  const { locale } = useRouter5();
  const { data: categories } = useGetCategories({
    lang: locale,
    where: { slug_not: currentSlug, parent_exists: root ? false : null },
    limit: 5
  });
  if (!(categories == null ? void 0 : categories.length)) {
    return null;
  }
  return /* @__PURE__ */ jsx6(
    FindMore_default,
    {
      links: categories.map((cat) => ({
        label: cat.title,
        href: `/${cat.slug}`,
        shape: "text",
        theme: "action"
      })),
      className: twMerge2("[&_p]:text-body-light [&_hr]:border-body-light container", className)
    }
  );
};
var MoreCategories_default = MoreCategories;

// src/components/events/card/FeaturedListItem.tsx
import { Button as Button4, Typography as Typography4 } from "@wbk/ui";
import { twMerge as twMerge3 } from "tailwind-merge";
import { Link, useRouter as useRouter6 } from "@wbk/config";
import { jsx as jsx7, jsxs as jsxs6 } from "react/jsx-runtime";
var FeaturedListItem = ({ event, className, onClick }) => {
  var _a;
  const { locale } = useRouter6();
  return /* @__PURE__ */ jsxs6(
    Button4,
    {
      href: `/${locale}/${event.category.slug}/${event.slug}`,
      as: Link,
      className: twMerge3("flex w-full items-center gap-3 bg-transparent p-0 text-start", className),
      theme: "transparent",
      onClick,
      "data-testid": `item_${event.slug}`,
      children: [
        /* @__PURE__ */ jsx7(
          ContentfulMedia_default,
          {
            className: "aspect-1 rounded-S h-[120px] w-[120px] shrink-0 object-cover",
            media: event.image11,
            width: 120,
            height: 120,
            ratio: "1x1",
            fit: "thumb",
            placeholder: true
          }
        ),
        /* @__PURE__ */ jsxs6("div", { className: "w-full space-y-1 py-1", children: [
          /* @__PURE__ */ jsx7("div", { className: "flex items-start justify-between", children: /* @__PURE__ */ jsx7(Typography4, { variant: "label-M", className: "line-clamp-2 grow", children: event.title }) }),
          /* @__PURE__ */ jsx7(Typography4, { variant: "body-S", className: "text-secondary-800 line-clamp-1", children: (_a = event.location) == null ? void 0 : _a.city }),
          /* @__PURE__ */ jsx7(Price_default, { event }),
          /* @__PURE__ */ jsx7(
            Sellers_default,
            {
              sellers: event.sellersCollection,
              className: "*:!text-secondary-800 *:text-body-S items-center"
            }
          )
        ] })
      ]
    }
  );
};
var FeaturedListItem_default = FeaturedListItem;

// src/components/calendar/FeaturedSection.tsx
import { jsx as jsx8, jsxs as jsxs7 } from "react/jsx-runtime";
var FeaturedSection = ({ section }) => {
  var _a, _b;
  const { t } = useTranslation4("calendar_common");
  const { locale } = useRouter7();
  const title = (section == null ? void 0 : section.title) || t("calendar_common:event_calendar.hero_title");
  const background = ((_a = section == null ? void 0 : section.sectionBackground) == null ? void 0 : _a.url) || "/@wbk/calendar/images/calendar/calendar-featured.png";
  const subTitle = (section == null ? void 0 : section.subtitle) || t("calendar_common:most_popular");
  const { data, isLoading } = useGetEventsList({
    lang: locale,
    where: { featured: true },
    limit: DEFAULT_PAGINATION
  });
  if (isLoading) {
    return /* @__PURE__ */ jsxs7(
      "section",
      {
        "data-bg": !!background,
        className: "space-y-M group relative bg-cover bg-no-repeat py-12",
        style: { backgroundImage: `url(${background})` },
        children: [
          /* @__PURE__ */ jsx8("div", { className: "bg-body-dark/70 absolute inset-0 top-0" }),
          /* @__PURE__ */ jsxs7("div", { className: "container relative z-10 space-y-6", children: [
            /* @__PURE__ */ jsx8("div", { className: "bg-body-level-1/30 h-8 w-32 animate-pulse rounded-lg" }),
            /* @__PURE__ */ jsx8("div", { className: "bg-body-level-1/30 h-12 w-2/3 animate-pulse rounded-lg" }),
            /* @__PURE__ */ jsx8("div", { className: "bg-body-level-1/30 h-8 w-1/3 animate-pulse rounded-lg" }),
            /* @__PURE__ */ jsx8("div", { className: "flex gap-12 overflow-x-hidden pb-2", children: [1, 2, 3].map((i) => /* @__PURE__ */ jsx8(
              "div",
              {
                className: "relative flex shrink-0 basis-80 items-center sm:basis-[480px] ltr:mr-4 rtl:ml-4",
                children: /* @__PURE__ */ jsx8("div", { className: "bg-body-level-1/30 h-[120px] w-full animate-pulse rounded-lg" })
              },
              i
            )) }),
            /* @__PURE__ */ jsx8("div", { className: "bg-body-level-1/30 h-12 w-full animate-pulse rounded-lg" })
          ] })
        ]
      }
    );
  }
  if (!((_b = data == null ? void 0 : data.items) == null ? void 0 : _b.length)) {
    return null;
  }
  const Element = section ? DecoratedSection_default : "section";
  return /* @__PURE__ */ jsxs7(
    Element,
    {
      section,
      className: "group relative bg-cover bg-no-repeat py-12",
      style: { backgroundImage: background },
      children: [
        /* @__PURE__ */ jsx8("div", { className: "bg-body-dark/70 absolute inset-0 top-0" }),
        /* @__PURE__ */ jsxs7("div", { className: "space-y-8", children: [
          /* @__PURE__ */ jsxs7("div", { className: "container relative z-10 space-y-6", children: [
            /* @__PURE__ */ jsx8(Typography5, { variant: "display-S", className: "text-body-light", children: title }),
            /* @__PURE__ */ jsx8(Typography5, { variant: "heading-M", className: "text-body-light", children: subTitle })
          ] }),
          /* @__PURE__ */ jsx8(Carousel2, { options: { dragFree: true }, className: "container-1/2 py-1", children: data.items.map((event, i) => /* @__PURE__ */ jsxs7(
            "div",
            {
              className: "relative flex shrink-0 basis-96 items-center sm:basis-[480px] sm:gap-2 ltr:mr-4 rtl:ml-4",
              children: [
                /* @__PURE__ */ jsx8(
                  Typography5,
                  {
                    variant: "display-L",
                    className: "text-body-light shrink-0 text-[170px] [-webkit-text-fill-color:transparent] [-webkit-text-stroke:1px] [text-fill-color:transparent] [text-stroke:1px]",
                    children: i + 1
                  }
                ),
                /* @__PURE__ */ jsx8(FeaturedListItem_default, { event, className: "*:!text-body-light" })
              ]
            },
            i
          )) }),
          !section && /* @__PURE__ */ jsx8(MoreCategories_default, {})
        ] })
      ]
    }
  );
};
var FeaturedSection_default = FeaturedSection;

// src/components/buttons/BackButton.tsx
import { ArrowIcon as ArrowIcon2 } from "@wbk/svg";
import { Link as Link2 } from "@wbk/config";
import { Button as Button5, Typography as Typography6 } from "@wbk/ui";
import { jsx as jsx9, jsxs as jsxs8 } from "react/jsx-runtime";
var BackButton = ({ name, href, className }) => {
  return /* @__PURE__ */ jsxs8(Button5, { as: Link2, to: href, className: `text-body-light p-0 ${className}`, shape: "text", children: [
    /* @__PURE__ */ jsx9(ArrowIcon2, { className: "h-4 w-4 shrink-0 rotate-0 ltr:mr-2 rtl:ml-2 rtl:rotate-180" }),
    /* @__PURE__ */ jsx9(Typography6, { as: "span", children: name })
  ] });
};
var BackButton_default = BackButton;

// src/pages/calendar/index.tsx
import { jsx as jsx10, jsxs as jsxs9 } from "react/jsx-runtime";
var CalendarPage = () => {
  const { t } = useTranslation5("calendar_common");
  const { locale } = useRouter8();
  return /* @__PURE__ */ jsxs9("div", { className: "bg-body", children: [
    /* @__PURE__ */ jsx10("div", { className: "container py-4", children: /* @__PURE__ */ jsx10(BackButton_default, { className: "text-text", name: t("calendar_common:home"), href: `/${locale}` }) }),
    /* @__PURE__ */ jsx10(EventsCalendar_default, {}),
    /* @__PURE__ */ jsx10(FeaturedSection_default, {})
  ] });
};
var calendar_default = CalendarPage;

// src/pages/category/index.tsx
import { Button as Button8, Carousel as Carousel5, Typography as Typography9 } from "@wbk/ui";
import { Link as Link3, useRouter as useRouter11, useTranslation as useTranslation8 } from "@wbk/config";

// src/components/filters/categories/List.tsx
import { Carousel as Carousel4 } from "@wbk/ui";
import { useRouter as useRouter10 } from "@wbk/config";

// src/components/filters/tags/List.tsx
import { useMemo } from "react";
import { useRouter as useRouter9 } from "@wbk/config";
import { Carousel as Carousel3 } from "@wbk/ui";
import { jsx as jsx11 } from "react/jsx-runtime";
var TagsFilterList = () => {
  var _a, _b, _c;
  const { locale } = useRouter9();
  const { state, setState } = useFilterState();
  const { query } = useFilterQuery_default();
  const { data: subcategory, isLoading } = useGetCategoryDetail(
    {
      lang: locale,
      where: { slug: state.subcategory },
      limit: 1
    },
    { enabled: !!state.subcategory }
  );
  const hasTag = !!state.tag;
  const hasTags = !!((_b = (_a = subcategory == null ? void 0 : subcategory.tagsCollection) == null ? void 0 : _a.items) == null ? void 0 : _b.length);
  const getTotal = hasTags && !hasTag;
  const { data: totals, isLoading: totalLoading } = useGetTagsTotalEvents(
    __spreadValues({
      tags: ((_c = subcategory == null ? void 0 : subcategory.tagsCollection) == null ? void 0 : _c.items) || []
    }, query),
    {
      enabled: getTotal
    }
  );
  const sortedTags = useMemo(() => {
    var _a2;
    const tags = (_a2 = subcategory == null ? void 0 : subcategory.tagsCollection) == null ? void 0 : _a2.items;
    return (tags == null ? void 0 : tags.sort(
      (a, b) => {
        var _a3, _b2, _c2, _d;
        return (((_b2 = (_a3 = b.linkedFrom) == null ? void 0 : _a3.eventCollection) == null ? void 0 : _b2.total) || 0) - (((_d = (_c2 = a.linkedFrom) == null ? void 0 : _c2.eventCollection) == null ? void 0 : _d.total) || 0);
      }
    )) || [];
  }, [subcategory]);
  if (isLoading) {
    return /* @__PURE__ */ jsx11("div", { className: "flex overflow-auto", children: Array.from({ length: 5 }).map((_, index) => /* @__PURE__ */ jsx11(
      "div",
      {
        className: "bg-body-level-2 h-12 w-36 shrink-0 animate-pulse rounded-md ltr:mr-4 rtl:ml-4"
      },
      index
    )) });
  }
  if (!(sortedTags == null ? void 0 : sortedTags.length)) {
    return null;
  }
  return /* @__PURE__ */ jsx11(
    Carousel3,
    {
      as: "ul",
      className: "py-0.5",
      arrowsClassName: "[&>button]:m-0 hidden lg:block",
      options: { dragFree: true },
      arrows: "middle",
      children: sortedTags.map((tag) => {
        var _a2;
        return /* @__PURE__ */ jsx11("li", { className: "shrink-0 ltr:mr-3 rtl:ml-3", children: /* @__PURE__ */ jsx11(
          Link_default,
          {
            item: tag,
            selected: state.tag === tag.slug,
            onClick: () => {
              setState({
                tag: state.tag === tag.slug ? void 0 : tag.slug
              });
            },
            total: (_a2 = totals == null ? void 0 : totals[tag.slug]) == null ? void 0 : _a2.total,
            totalLoading
          }
        ) }, tag.slug);
      })
    }
  );
};
var List_default = TagsFilterList;

// src/components/filters/categories/List.tsx
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var CategoryFilterList = ({
  parent,
  categories: predefinedCategories,
  showParent = false
}) => {
  const { locale } = useRouter10();
  const { state, setState } = useFilterState();
  const { data: categories, isLoading } = useGetCategories(
    {
      lang: locale,
      where: { parent_exists: false }
    },
    {
      enabled: showParent
    }
  );
  const { data: subcategories, isLoading: isSubcategoriesLoading } = useGetCategories(
    {
      lang: locale,
      where: showParent ? {
        parent: { slug: state.category }
      } : parent ? { parent: { slug: parent } } : { parent_exists: true }
    },
    {
      enabled: showParent ? !!state.category : !(predefinedCategories == null ? void 0 : predefinedCategories.length)
    }
  );
  const allSubcategories = predefinedCategories || subcategories || [];
  if (isLoading) {
    return /* @__PURE__ */ jsx12(Skeleton, {});
  }
  const isEmpty = showParent ? !(categories == null ? void 0 : categories.length) : !(allSubcategories == null ? void 0 : allSubcategories.length);
  if (isEmpty)
    return null;
  return /* @__PURE__ */ jsxs10("div", { className: "space-y-3", children: [
    showParent && (categories == null ? void 0 : categories.length) && /* @__PURE__ */ jsx12(
      Carousel4,
      {
        as: "ul",
        className: "py-0.5",
        arrowsClassName: "[&>button]:m-0 hidden 2xl:block",
        options: { dragFree: true },
        arrows: "middle",
        children: categories == null ? void 0 : categories.map((category) => /* @__PURE__ */ jsx12("li", { className: "shrink-0 ltr:mr-3 rtl:ml-3", children: /* @__PURE__ */ jsx12(
          Link_default,
          {
            item: category,
            selected: state.category === category.slug,
            onClick: () => {
              setState({
                category: state.category === category.slug ? void 0 : category.slug,
                subcategory: void 0,
                tag: void 0
              });
            }
          }
        ) }, category.slug))
      }
    ),
    isSubcategoriesLoading ? /* @__PURE__ */ jsx12(Skeleton, {}) : (allSubcategories == null ? void 0 : allSubcategories.length) ? /* @__PURE__ */ jsx12(
      Carousel4,
      {
        as: "ul",
        className: "py-0.5",
        options: { dragFree: true },
        arrowsClassName: "[&>button]:m-0 hidden 2xl:block",
        arrows: "middle",
        children: allSubcategories.map((subcategory) => /* @__PURE__ */ jsx12("li", { className: "shrink-0 ltr:mr-3 rtl:ml-3", children: /* @__PURE__ */ jsx12(
          Link_default,
          {
            item: subcategory,
            selected: state.subcategory === subcategory.slug,
            onClick: () => {
              setState({
                subcategory: state.subcategory === subcategory.slug ? void 0 : subcategory.slug,
                tag: void 0
              });
            }
          }
        ) }, subcategory.slug))
      }
    ) : null,
    /* @__PURE__ */ jsx12(List_default, {})
  ] });
};
var Skeleton = () => {
  return /* @__PURE__ */ jsx12("div", { className: "flex overflow-auto", children: Array.from({ length: 5 }).map((_, index) => /* @__PURE__ */ jsx12(
    "div",
    {
      className: "bg-body-level-2 h-12 w-36 shrink-0 animate-pulse rounded-md ltr:mr-4 rtl:ml-4"
    },
    index
  )) });
};
var List_default2 = CategoryFilterList;

// src/components/filters/Sort.tsx
import { Trans, useTranslation as useTranslation6 } from "@wbk/config";
import { Button as Button6, ResponsiveMenu, Typography as Typography7 } from "@wbk/ui";
import { ChevronIcon } from "@wbk/svg";
import { jsx as jsx13, jsxs as jsxs11 } from "react/jsx-runtime";
var options = [
  {
    text: /* @__PURE__ */ jsx13(Trans, { i18nKey: "highest_rated", ns: "calendar_explore" }),
    value: ""
  },
  {
    text: /* @__PURE__ */ jsx13(Trans, { i18nKey: "price_low_to_high", ns: "calendar_explore" }),
    value: "lowest_price"
  },
  {
    text: /* @__PURE__ */ jsx13(Trans, { i18nKey: "price_high_to_low", ns: "calendar_explore" }),
    value: "highest_price"
  },
  {
    text: /* @__PURE__ */ jsx13(Trans, { i18nKey: "newest", ns: "calendar_explore" }),
    value: "newest"
  },
  {
    text: /* @__PURE__ */ jsx13(Trans, { i18nKey: "oldest", ns: "calendar_explore" }),
    value: "oldest"
  }
];
var ExploreSort = ({ total }) => {
  const { state, setState } = useFilterState();
  const { t } = useTranslation6(["calendar_explore", "calendar_common"]);
  const sortValue = state.sort;
  if (!total)
    return /* @__PURE__ */ jsx13("div", {});
  return /* @__PURE__ */ jsx13(
    ResponsiveMenu,
    {
      className: "inline",
      render: ({ open, selected }) => /* @__PURE__ */ jsxs11("div", { className: "inline items-center", children: [
        /* @__PURE__ */ jsx13(Typography7, { children: t("calendar_explore:result_and_sort", { total }) }),
        /* @__PURE__ */ jsxs11(Button6, { shape: "text", className: "px-2 py-1", onClick: open, children: [
          /* @__PURE__ */ jsx13(Typography7, { as: "span", variant: "link-M", children: selected == null ? void 0 : selected.text }),
          /* @__PURE__ */ jsx13(ChevronIcon, { className: "h-3 w-3 shrink-0 rotate-90" })
        ] })
      ] }),
      item: { theme: "primary" },
      sheet: { ignoreHistory: true },
      options,
      value: sortValue,
      onChange: (op) => setState({ sort: op.value }),
      hideErrorSpace: true
    }
  );
};
var Sort_default = ExploreSort;

// src/components/events/EventsGrid.tsx
import { Fragment } from "react";
import { jsx as jsx14, jsxs as jsxs12 } from "react/jsx-runtime";
var EventsGrid = ({ events }) => {
  return /* @__PURE__ */ jsx14("div", { className: "grid grid-cols-1 gap-4 sm:grid-cols-[repeat(auto-fill,minmax(285px,1fr))]", children: events.map((event) => {
    return /* @__PURE__ */ jsxs12(Fragment, { children: [
      /* @__PURE__ */ jsx14(Item_default, { event, className: "hidden sm:block" }),
      /* @__PURE__ */ jsx14(ListItem_default, { event, className: "sm:hidden" })
    ] }, event.id);
  }) });
};
var EventsGrid_default = EventsGrid;

// src/components/filters/Pagination.tsx
import { useMemo as useMemo2 } from "react";
import { Button as Button7 } from "@wbk/ui";
import { jsx as jsx15 } from "react/jsx-runtime";
var SIBLING_COUNT = 1;
var DOTS = "...";
var ExplorePagination = ({ total }) => {
  const { state, setState } = useFilterState();
  const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, idx) => idx + start);
  };
  const paginationRange = useMemo2(() => {
    const totalPageCount = Math.ceil(total / state.perPage);
    const totalPageNumbers = SIBLING_COUNT + 5;
    if (totalPageNumbers >= totalPageCount) {
      return range(1, totalPageCount);
    }
    const leftSiblingIndex = Math.max(state.page - SIBLING_COUNT, 1);
    const rightSiblingIndex = Math.min(state.page + SIBLING_COUNT, totalPageCount);
    const shouldShowLeftDots = leftSiblingIndex > 2;
    const shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
    const firstPageIndex = 1;
    const lastPageIndex = totalPageCount;
    if (!shouldShowLeftDots && shouldShowRightDots) {
      const leftItemCount = 3 + 2 * SIBLING_COUNT;
      const leftRange = range(1, leftItemCount);
      return [...leftRange, DOTS, totalPageCount];
    }
    if (shouldShowLeftDots && !shouldShowRightDots) {
      const rightItemCount = 3 + 2 * SIBLING_COUNT;
      const rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
      return [firstPageIndex, DOTS, ...rightRange];
    }
    if (shouldShowLeftDots && shouldShowRightDots) {
      const middleRange = range(leftSiblingIndex, rightSiblingIndex);
      return [firstPageIndex, DOTS, ...middleRange, DOTS, lastPageIndex];
    }
  }, [total, state.perPage, state.page]);
  if (!(paginationRange == null ? void 0 : paginationRange.length) || paginationRange.length < 2)
    return null;
  return /* @__PURE__ */ jsx15("div", { className: "flex items-center justify-end gap-2", children: paginationRange.map((page) => /* @__PURE__ */ jsx15(
    Button7,
    {
      "data-dots": page === DOTS,
      as: page === DOTS ? "span" : "button",
      theme: page === DOTS ? "transparent" : state.page === page ? "primary" : "action",
      className: "h-10 w-10",
      onClick: () => {
        if (page === DOTS)
          return;
        setState({ page: Number(page) });
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      children: page
    },
    page
  )) });
};
var Pagination_default = ExplorePagination;

// src/components/explore/Empty.tsx
import { Typography as Typography8 } from "@wbk/ui";
import { useTranslation as useTranslation7 } from "@wbk/config";
import { SearchIcon } from "@wbk/svg";
import { jsx as jsx16, jsxs as jsxs13 } from "react/jsx-runtime";
var ExploreEmptyResult = () => {
  const { reset } = useFilterState();
  const { t } = useTranslation7("calendar_explore");
  return /* @__PURE__ */ jsxs13("div", { className: "space-y-6 py-4 text-center", children: [
    /* @__PURE__ */ jsx16("div", { className: "bg-body-level-2 mx-auto flex h-24 w-24 items-center justify-center space-y-4 rounded-full text-center", children: /* @__PURE__ */ jsx16(SearchIcon, { className: "h-14 w-14 shrink-0" }) }),
    /* @__PURE__ */ jsxs13("div", { className: "space-y-2", children: [
      /* @__PURE__ */ jsx16(Typography8, { variant: "heading-L", as: "h4", children: t("calendar_explore:empty_search") }),
      /* @__PURE__ */ jsx16(Typography8, { className: "text-text-secondary", children: t("calendar_explore:empty_search_desc") })
    ] }),
    /* @__PURE__ */ jsx16(ThemeButton_default, { onClick: reset, children: t("calendar_explore:reset_all_filters") })
  ] });
};
var Empty_default = ExploreEmptyResult;

// src/pages/category/index.tsx
import { Fragment as Fragment2, jsx as jsx17, jsxs as jsxs14 } from "react/jsx-runtime";
var CategoryPage = ({ category }) => {
  var _a;
  const { t } = useTranslation8("calendar_explore");
  const { locale } = useRouter11();
  const { query } = useFilterQuery_default({
    state: { category: category == null ? void 0 : category.slug }
  });
  const { data, isLoading } = useGetEventsList(query, { enabled: !!(category == null ? void 0 : category.slug) });
  const tags = ((_a = category == null ? void 0 : category.tagsCollection) == null ? void 0 : _a.items) || [];
  return /* @__PURE__ */ jsxs14(Fragment2, { children: [
    /* @__PURE__ */ jsx17("section", { className: "bg-body text-text py-12", children: /* @__PURE__ */ jsx17("div", { className: "container", children: /* @__PURE__ */ jsx17(Typography9, { as: "h1", variant: "display-M", children: category.title }) }) }),
    /* @__PURE__ */ jsxs14("section", { className: "container space-y-8 py-12", children: [
      /* @__PURE__ */ jsx17(List_default2, { parent: category.slug }),
      /* @__PURE__ */ jsxs14("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx17(Sort_default, { total: (data == null ? void 0 : data.total) || 0 }),
        /* @__PURE__ */ jsx17(Filters_default, {})
      ] }),
      isLoading ? /* @__PURE__ */ jsx17(EventLoading_default, {}) : (data == null ? void 0 : data.items.length) ? /* @__PURE__ */ jsxs14(Fragment2, { children: [
        /* @__PURE__ */ jsx17(EventsGrid_default, { events: data.items }),
        /* @__PURE__ */ jsx17(Pagination_default, { total: data.total })
      ] }) : /* @__PURE__ */ jsx17(Empty_default, {}),
      !!tags.length && /* @__PURE__ */ jsx17(
        Carousel5,
        {
          options: { dragFree: true },
          rootClassName: "space-y-4 [&_div]:p-0",
          title: /* @__PURE__ */ jsx17(Typography9, { variant: "body-L", color: "text-secondary", children: t("calendar_explore:relevant_tags") }),
          children: tags.map((tag) => {
            return /* @__PURE__ */ jsx17(
              Button8,
              {
                as: Link3,
                to: `/${locale}/tags/${tag.slug}`,
                phill: true,
                className: "bg-body-level-4 bg-body-dark/10 text-body-dark shrink-0 px-3 py-2 ltr:mr-2 rtl:ml-2",
                children: /* @__PURE__ */ jsx17(Typography9, { as: "span", children: tag.title })
              },
              tag.id
            );
          })
        }
      )
    ] })
  ] });
};
var category_default = CategoryPage;

// src/components/events/detail/EventHeader.tsx
import { useRouter as useRouter12, useTranslation as useTranslation10 } from "@wbk/config";
import { Typography as Typography12 } from "@wbk/ui";

// src/components/common/Breadcrumb.tsx
import { Fragment as Fragment3 } from "react";
import { Button as Button9, Typography as Typography10 } from "@wbk/ui";
import { Link as Link4 } from "@wbk/config";
import { twMerge as twMerge4 } from "tailwind-merge";
import { jsx as jsx18, jsxs as jsxs15 } from "react/jsx-runtime";
var Breadcrumb = ({ items }) => {
  return /* @__PURE__ */ jsx18("ul", { className: "flex list-none flex-wrap items-center text-sm", children: items == null ? void 0 : items.map(({ name, disabled, href, className, hide }, idx) => {
    if (hide)
      return null;
    return /* @__PURE__ */ jsxs15(Fragment3, { children: [
      /* @__PURE__ */ jsx18("li", { className: twMerge4("text-body-light inline items-center leading-tight", className), children: disabled ? /* @__PURE__ */ jsx18(Typography10, { children: name }) : /* @__PURE__ */ jsx18(Button9, { as: Link4, href, theme: "action", shape: "text", className: "p-px", children: /* @__PURE__ */ jsx18(Typography10, { children: name }) }) }),
      idx !== items.length - 1 ? /* @__PURE__ */ jsx18("span", { className: "text-body-light mx-2 inline", children: "/" }) : null
    ] }, idx);
  }) });
};
var Breadcrumb_default = Breadcrumb;

// src/components/events/detail/Actions.tsx
import { ShareModal, Typography as Typography11 } from "@wbk/ui";
import { Heart, SearchIcon as SearchIcon2, ShareArrow } from "@wbk/svg";
import { Link as Link5, useTranslation as useTranslation9 } from "@wbk/config";
import { twMerge as twMerge5 } from "tailwind-merge";
import { Fragment as Fragment4, jsx as jsx19, jsxs as jsxs16 } from "react/jsx-runtime";
var EventActions = ({ event, className }) => {
  const { t } = useTranslation9("calendar_event");
  const { isFavorite, toggleFavorite } = useFavorites();
  return /* @__PURE__ */ jsxs16("div", { className: twMerge5("flex items-center gap-2", className), children: [
    /* @__PURE__ */ jsx19(
      ThemeButton_default,
      {
        onClick: () => toggleFavorite(event.slug, event.title),
        className: "border-body-light text-body-light shrink-0 p-2",
        shape: "outlined",
        children: isFavorite(event.slug) ? /* @__PURE__ */ jsxs16(Fragment4, { children: [
          /* @__PURE__ */ jsx19(Heart, { className: "text-error h-5 w-5 stroke-transparent" }),
          /* @__PURE__ */ jsx19(Typography11, { className: "hidden md:block", children: t("calendar_event:remove_from_favorites") })
        ] }) : /* @__PURE__ */ jsxs16(Fragment4, { children: [
          /* @__PURE__ */ jsx19(Heart, { className: "stroke-body-light text-body-dark/10 h-5 w-5" }),
          /* @__PURE__ */ jsx19(Typography11, { className: "hidden md:block", children: t("calendar_event:add_to_favorites") })
        ] })
      }
    ),
    /* @__PURE__ */ jsx19(
      ShareModal,
      {
        data: {
          title: event == null ? void 0 : event.title,
          text: event == null ? void 0 : event.title
        },
        poster: event == null ? void 0 : event.image11.url,
        className: "border-body-light text-body-light gap-2",
        render: ({ share }) => /* @__PURE__ */ jsxs16(
          ThemeButton_default,
          {
            className: "border-body-light text-body-light shrink-0 p-2",
            shape: "outlined",
            onClick: share,
            children: [
              /* @__PURE__ */ jsx19(ShareArrow, { className: "h-5 w-5" }),
              /* @__PURE__ */ jsx19(Typography11, { className: "hidden md:block", children: t("calendar_event:share") })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ jsxs16(
      ThemeButton_default,
      {
        as: Link5,
        href: `/${event.category.slug}`,
        className: "border-body-light text-body-light shrink-0 p-2",
        shape: "outlined",
        children: [
          /* @__PURE__ */ jsx19(SearchIcon2, { className: "h-5 w-5" }),
          /* @__PURE__ */ jsx19(Typography11, { className: "hidden md:block", children: t("calendar_event:similar_events") })
        ]
      }
    )
  ] });
};
var Actions_default = EventActions;

// src/components/events/detail/EventHeader.tsx
import { Fragment as Fragment5, jsx as jsx20, jsxs as jsxs17 } from "react/jsx-runtime";
var EventHeader = ({ event }) => {
  const { t } = useTranslation10(["calendar_common", "calendar_event"]);
  const { locale } = useRouter12();
  return /* @__PURE__ */ jsxs17(Fragment5, { children: [
    /* @__PURE__ */ jsxs17("div", { className: "flex items-center justify-between gap-4", children: [
      /* @__PURE__ */ jsx20(
        Breadcrumb_default,
        {
          items: [
            {
              href: `/${locale}`,
              name: t("calendar_common:home")
            },
            {
              href: `/${locale}/${event.category.slug}`,
              name: event.category.title
            }
          ]
        }
      ),
      /* @__PURE__ */ jsx20(Actions_default, { event, className: "flex lg:hidden" })
    ] }),
    /* @__PURE__ */ jsxs17("div", { className: "flex items-start justify-between gap-4", children: [
      /* @__PURE__ */ jsx20(Typography12, { as: "h1", variant: "display-S", className: "text-body-light", children: event.title }),
      /* @__PURE__ */ jsx20(Actions_default, { event, className: "hidden shrink-0 pt-2 lg:flex" })
    ] })
  ] });
};
var EventHeader_default = EventHeader;

// src/components/events/detail/GetToLocation.tsx
import { useTranslation as useTranslation12 } from "@wbk/config";
import { Button as Button11, Typography as Typography14 } from "@wbk/ui";

// src/components/events/detail/EventLocation.tsx
import { useTranslation as useTranslation11 } from "@wbk/config";
import { twMerge as twMerge6 } from "tailwind-merge";
import { Button as Button10, Typography as Typography13 } from "@wbk/ui";
import { jsx as jsx21, jsxs as jsxs18 } from "react/jsx-runtime";
var EventLocation = ({ location, className }) => {
  const { t } = useTranslation11("calendar_event");
  const address = location == null ? void 0 : location.address;
  if (!address) {
    return null;
  }
  return /* @__PURE__ */ jsxs18("div", { className: twMerge6("space-y-2", className), children: [
    /* @__PURE__ */ jsx21(Typography13, { children: t("calendar_event:location") }),
    location.location.lat && location.location.lon ? /* @__PURE__ */ jsx21(
      Button10,
      {
        as: "a",
        target: "_blank",
        rel: "noreferrer",
        href: `https://www.google.com/maps/search/?api=1&query=${location.location.lat},${location.location.lon}`,
        className: "p-0 text-start",
        shape: "text",
        children: /* @__PURE__ */ jsx21(Typography13, { variant: "link-L", children: address })
      }
    ) : /* @__PURE__ */ jsx21(Typography13, { variant: "body-L", children: address })
  ] });
};
var EventLocation_default = EventLocation;

// src/components/events/detail/GetToLocation.tsx
import { jsx as jsx22, jsxs as jsxs19 } from "react/jsx-runtime";
var GetToLocation = ({ event }) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const { t } = useTranslation12("calendar_event");
  const subway = {
    name: (_a = event.location) == null ? void 0 : _a.subwayStation,
    distance: (_b = event.location) == null ? void 0 : _b.subwayStationDistance,
    location: (_c = event.location) == null ? void 0 : _c.subwayStationLocation,
    srcIcon: "/@wbk/calendar/icons/stations/subway-station.png"
  };
  const bus = {
    name: (_d = event.location) == null ? void 0 : _d.busStation,
    distance: (_e = event.location) == null ? void 0 : _e.busStationDistance,
    location: (_f = event.location) == null ? void 0 : _f.busStationLocation,
    srcIcon: "/@wbk/calendar/icons/stations/bus-station.png"
  };
  if (!subway.location && !bus.location)
    return null;
  return /* @__PURE__ */ jsx22("section", { className: "border-paper border-b py-12", children: /* @__PURE__ */ jsxs19("div", { className: "divide-paper container flex flex-col items-start gap-5 md:flex-row md:flex-wrap md:gap-10 md:divide-x rtl:divide-x-reverse", children: [
    /* @__PURE__ */ jsx22(EventLocation_default, { location: event.location }),
    ((_g = subway.location) == null ? void 0 : _g.lat) && ((_h = subway.location) == null ? void 0 : _h.lon) && /* @__PURE__ */ jsxs19("div", { className: "flex items-center gap-4 md:px-4", children: [
      /* @__PURE__ */ jsx22(
        "img",
        {
          src: subway.srcIcon,
          alt: subway.name,
          className: "aspect-1 h-10 w-10 object-contain"
        }
      ),
      /* @__PURE__ */ jsxs19("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx22(Typography14, { children: t("calendar_event:stations.nearest_subway_station") }),
        /* @__PURE__ */ jsx22(
          Button11,
          {
            as: "a",
            target: "_blank",
            rel: "noreferrer",
            href: `https://www.google.com/maps/search/?api=1&query=${subway.location.lat},${subway.location.lon}`,
            className: "p-0",
            shape: "text",
            children: /* @__PURE__ */ jsx22(Typography14, { variant: "link-L", children: subway.name })
          }
        ),
        /* @__PURE__ */ jsx22(Typography14, { variant: "body-S", children: subway.distance })
      ] })
    ] }),
    ((_i = bus.location) == null ? void 0 : _i.lat) && ((_j = bus.location) == null ? void 0 : _j.lon) && /* @__PURE__ */ jsxs19("div", { className: "flex items-center gap-4 md:px-4", children: [
      /* @__PURE__ */ jsx22("img", { src: bus.srcIcon, alt: bus.name, className: "aspect-1 h-10 w-10 object-contain" }),
      /* @__PURE__ */ jsxs19("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx22(Typography14, { children: t("calendar_event:stations.nearest_bus_stop") }),
        /* @__PURE__ */ jsx22(
          Button11,
          {
            as: "a",
            target: "_blank",
            rel: "noreferrer",
            href: `https://www.google.com/maps/search/?api=1&query=${bus.location.lat},${bus.location.lon}`,
            className: "p-0",
            shape: "text",
            children: /* @__PURE__ */ jsx22(Typography14, { variant: "link-L", children: bus.name })
          }
        ),
        /* @__PURE__ */ jsx22(Typography14, { variant: "body-S", children: bus.distance })
      ] })
    ] }),
    /* @__PURE__ */ jsxs19("div", { className: "space-y-1 md:px-4", children: [
      /* @__PURE__ */ jsx22(Typography14, { children: t("calendar_event:stations.cars_on_demand") }),
      /* @__PURE__ */ jsx22("div", { className: "flex items-center gap-2 py-2", children: Array.from({ length: 5 }, (_, i) => /* @__PURE__ */ jsx22(
        "img",
        {
          src: `/@wbk/calendar/icons/car-app/car-app-${i}.png`,
          alt: `car-app-${i}`,
          className: "aspect-1 h-8 w-8 rounded object-contain"
        },
        i
      )) }),
      /* @__PURE__ */ jsx22(Typography14, { variant: "body-S", children: t("calendar_event:stations.download_the_app_and_order") })
    ] })
  ] }) });
};
var GetToLocation_default = GetToLocation;

// src/components/events/detail/EventDetails.tsx
import { Divider } from "@wbk/ui";

// src/components/events/gallery/EventGallery.tsx
import { useState as useState2 } from "react";
import { useTranslation as useTranslation13 } from "@wbk/config";
import { Button as Button12, Gallery, ImageWithPlaceholder } from "@wbk/ui";

// src/components/events/gallery/GalleryWithThumbs.tsx
import { useMemo as useMemo3, useState } from "react";
import { Carousel as Carousel6 } from "@wbk/ui";
import { jsx as jsx23, jsxs as jsxs20 } from "react/jsx-runtime";
var GalleryWithThumbs = ({ poster, carousel, className }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const list = useMemo3(() => {
    if (carousel && carousel.length > 1) {
      return carousel;
    }
    return [poster];
  }, [carousel, poster]);
  return /* @__PURE__ */ jsxs20("div", { className: `relative ${className}`, children: [
    /* @__PURE__ */ jsx23(
      Carousel6,
      {
        rootClassName: "aspect-1 mx-auto w-full",
        className: "aspect-1 mx-auto w-full",
        thumbClassName: "mx-auto pt-2",
        autoplay: true,
        onIndexChanged: (index) => setActiveIndex(index),
        children: list.map((image, i) => /* @__PURE__ */ jsx23("div", { className: "aspect-1 mr-1 shrink-0 basis-full", children: /* @__PURE__ */ jsx23("figure", { className: "h-full w-full", children: /* @__PURE__ */ jsx23(
          ContentfulMedia_default,
          {
            className: "h-full w-full overflow-hidden rounded-lg object-cover",
            media: {
              title: image.title,
              url: image.url,
              height: 600,
              width: 600,
              contentType: "image",
              sys: {
                id: "",
                publishedAt: ""
              }
            },
            placeholder: true
          }
        ) }) }, image.url + i))
      }
    ),
    /* @__PURE__ */ jsx23("div", { className: "absolute bottom-0 left-0 flex w-full justify-center gap-2 px-4 py-2", children: list.map((_, i) => /* @__PURE__ */ jsx23(
      "div",
      {
        className: `h-1 flex-1 rounded-full transition-all ${i === activeIndex ? "bg-body-light" : "bg-body-light/20"}`
      },
      i
    )) })
  ] });
};
var GalleryWithThumbs_default = GalleryWithThumbs;

// src/components/events/gallery/EventGallery.tsx
import { Fragment as Fragment6, jsx as jsx24, jsxs as jsxs21 } from "react/jsx-runtime";
var EventGallery = ({ event }) => {
  var _a;
  const { t } = useTranslation13("calendar_event");
  const [currentIndex, setCurrentIndex] = useState2(0);
  const images = ((_a = event.carousalCollection) == null ? void 0 : _a.items) || [event.image11];
  const list = images.slice(0, 2);
  const sublist = images.slice(2, 4);
  const showMoreButton = images.length > 2;
  if (images.length <= 1) {
    return /* @__PURE__ */ jsx24(
      ContentfulMedia_default,
      {
        className: "mx-auto w-full max-w-md rounded-md object-cover object-center xl:max-w-xl",
        media: event.image11,
        placeholder: true
      }
    );
  }
  return /* @__PURE__ */ jsxs21(Fragment6, { children: [
    /* @__PURE__ */ jsx24(
      Gallery,
      {
        startIndex: currentIndex,
        render: ({ open }) => {
          return /* @__PURE__ */ jsxs21("div", { "data-images": images.length, className: "relative hidden gap-2 sm:flex lg:hidden", children: [
            list.map((poster, i) => /* @__PURE__ */ jsx24(
              Button12,
              {
                onClick: () => {
                  open();
                  setCurrentIndex(i);
                },
                theme: "white",
                className: "relative aspect-[1/1] max-h-[400px] w-full flex-1 bg-transparent hover:bg-transparent [&:nth-child(1)]:basis-[20%] [&:nth-child(2)]:basis-[20%]",
                children: /* @__PURE__ */ jsx24(
                  ImageWithPlaceholder,
                  {
                    src: poster.url,
                    className: "absolute inset-0 h-full w-full cursor-pointer rounded-md object-cover",
                    alt: "restaurant-test"
                  }
                )
              },
              i
            )),
            sublist.length > 1 && /* @__PURE__ */ jsx24("div", { className: "hidden flex-1 space-y-2 md:block", children: sublist.map((poster, i) => /* @__PURE__ */ jsx24(
              Button12,
              {
                onClick: () => {
                  open();
                  setCurrentIndex(i + 2);
                },
                theme: "white",
                className: "aspect-1 relative max-h-[196px] w-full flex-1 bg-transparent hover:bg-transparent",
                children: /* @__PURE__ */ jsx24(
                  ImageWithPlaceholder,
                  {
                    src: poster.url,
                    className: "absolute inset-0 h-full w-full cursor-pointer rounded-md object-cover",
                    alt: "restaurant-test"
                  }
                )
              },
              i + 2
            )) }),
            showMoreButton && /* @__PURE__ */ jsx24(
              Button12,
              {
                theme: "white",
                shape: "solid",
                "data-images": images.length,
                className: "absolute bottom-2 text-xs data-[images=4]:md:hidden ltr:right-7 rtl:left-7",
                onClick: () => {
                  open();
                  setCurrentIndex(list.length + sublist.length);
                },
                children: t("calendar_event:see_all_photos", { number: images.length })
              }
            )
          ] });
        },
        slides: images.map((img) => ({
          src: img.url,
          title: img.title || event.title
        }))
      }
    ),
    /* @__PURE__ */ jsx24(
      GalleryWithThumbs_default,
      {
        className: "block sm:hidden lg:block",
        poster: event.image11,
        carousel: images
      }
    )
  ] });
};
var EventGallery_default = EventGallery;

// src/components/events/EventStartPrice.tsx
import { useTranslation as useTranslation14 } from "@wbk/config";
import { twMerge as twMerge7 } from "tailwind-merge";
import { CurrencyPriceLabel } from "@wbk/currency";
import { Typography as Typography15 } from "@wbk/ui";
import { jsx as jsx25, jsxs as jsxs22 } from "react/jsx-runtime";
var EventStartPrice = ({ event, className }) => {
  const { t } = useTranslation14("calendar_event");
  if (!event.price) {
    return null;
  }
  return /* @__PURE__ */ jsxs22("div", { className: twMerge7("flex shrink-0 flex-col gap-1", className), children: [
    /* @__PURE__ */ jsxs22("div", { className: "flex items-center gap-1", children: [
      /* @__PURE__ */ jsx25(Typography15, { variant: "body-S", className: "text-body-light/70", children: t("calendar_event:starts_from") }),
      /* @__PURE__ */ jsx25(
        CurrencyPriceLabel,
        {
          originalPrice: event.price,
          currency: event.currency.code,
          changeable: true,
          className: "text-body-light",
          currencyClassName: "text-body-light"
        }
      ),
      event.priceUnit && /* @__PURE__ */ jsxs22(Typography15, { variant: "body-XS", className: "text-body-light/80", children: [
        "/ ",
        event.priceUnit
      ] })
    ] }),
    /* @__PURE__ */ jsx25(Sellers_default, { sellers: event.sellersCollection, icon: false, link: true, className: "text-body-light/80" })
  ] });
};
var EventStartPrice_default = EventStartPrice;

// src/components/events/Tags.tsx
import { Link as Link6, useRouter as useRouter13, useTranslation as useTranslation15 } from "@wbk/config";
import { Button as Button13, Typography as Typography16 } from "@wbk/ui";
import { jsx as jsx26, jsxs as jsxs23 } from "react/jsx-runtime";
var Tags = ({ tags }) => {
  const { locale } = useRouter13();
  const { t } = useTranslation15("calendar_event");
  if (!(tags == null ? void 0 : tags.length))
    return null;
  return /* @__PURE__ */ jsxs23("div", { className: "text-body-light space-y-4", children: [
    /* @__PURE__ */ jsx26(Typography16, { variant: "body-L", children: t("calendar_event:tags") }),
    /* @__PURE__ */ jsx26("div", { className: "flex flex-wrap items-center gap-2", children: tags == null ? void 0 : tags.map((tag) => /* @__PURE__ */ jsx26(
      Button13,
      {
        as: Link6,
        to: `/${locale}/tags/${tag.slug}`,
        phill: true,
        className: "bg-body-light/10 text-body-light shrink-0 px-3 py-2",
        children: /* @__PURE__ */ jsx26(Typography16, { as: "span", children: tag.title })
      },
      tag.id
    )) })
  ] });
};
var Tags_default = Tags;

// src/components/events/detail/AllowedAge.tsx
import { Typography as Typography17 } from "@wbk/ui";
import { useTranslation as useTranslation16 } from "@wbk/config";
import { jsx as jsx27, jsxs as jsxs24 } from "react/jsx-runtime";
var AllowedAge = ({ ageRange }) => {
  const { t } = useTranslation16("calendar_event");
  if (!ageRange)
    return null;
  return /* @__PURE__ */ jsxs24("div", { className: "text-body-light space-y-2", children: [
    /* @__PURE__ */ jsx27(Typography17, { children: t("calendar_event:age.title") }),
    /* @__PURE__ */ jsx27(Typography17, { variant: "body-L", children: ageRange.title })
  ] });
};
var AllowedAge_default = AllowedAge;

// src/components/events/detail/BuyButton.tsx
import { useTranslation as useTranslation17 } from "@wbk/config";
import { twMerge as twMerge8 } from "tailwind-merge";
import { useAnalytics } from "@wbk/analytics";
import { Typography as Typography18 } from "@wbk/ui";
import { ArrowIcon as ArrowIcon3 } from "@wbk/svg";
import { jsx as jsx28, jsxs as jsxs25 } from "react/jsx-runtime";
var BuyTicketButton = ({ event, className }) => {
  var _a;
  const { t } = useTranslation17("calendar_event");
  const { generateLeadEvent } = useAnalytics();
  if (!event.button.href) {
    return null;
  }
  const handleGenerateLead = () => {
    var _a2;
    generateLeadEvent({
      event_start_price: event.price,
      currency: (_a2 = event.currency) == null ? void 0 : _a2.code,
      title: event.title,
      slug: event.slug
    });
  };
  return /* @__PURE__ */ jsxs25(
    ThemeButton_default,
    {
      theme: "action",
      as: "a",
      href: event.button.href,
      target: "_blank",
      rel: "noopener noreferrer",
      onClick: handleGenerateLead,
      className: twMerge8("min-h-12 w-full gap-2", className),
      children: [
        /* @__PURE__ */ jsx28(Typography18, { as: "span", variant: "label-L", children: event.button.label || t("calendar_event:book_tickets") }),
        ((_a = event.button.icon) == null ? void 0 : _a.url) ? /* @__PURE__ */ jsx28("img", { src: event.button.icon.url, width: 16, height: 16, alt: "" }) : /* @__PURE__ */ jsx28(ArrowIcon3, { className: "h-5 w-5 ltr:-rotate-45 ltr:-scale-x-100 rtl:rotate-45" })
      ]
    }
  );
};
var BuyButton_default = BuyTicketButton;

// src/components/events/detail/EventDateTime.tsx
import { useRouter as useRouter14, useTranslation as useTranslation18 } from "@wbk/config";
import { twMerge as twMerge9 } from "tailwind-merge";
import { formatDate as formatDate4 } from "@wbk/utils";
import { Typography as Typography19 } from "@wbk/ui";
import { jsx as jsx29, jsxs as jsxs26 } from "react/jsx-runtime";
var EventDateTime = ({ schedule, className }) => {
  const { locale } = useRouter14();
  const { t } = useTranslation18("calendar_event");
  const title = (schedule == null ? void 0 : schedule.title) || t("calendar_event:date");
  const open = schedule == null ? void 0 : schedule.openDateTime;
  const close = schedule == null ? void 0 : schedule.closeDateTime;
  const notSame = !!close && open !== close;
  if (!schedule || !open)
    return null;
  if (schedule == null ? void 0 : schedule.text) {
    return /* @__PURE__ */ jsxs26("div", { className: twMerge9("text-body-light space-y-2", className), children: [
      /* @__PURE__ */ jsx29(Typography19, { children: title }),
      /* @__PURE__ */ jsx29(Typography19, { variant: "body-L", children: schedule.text })
    ] });
  }
  return /* @__PURE__ */ jsxs26("div", { className: twMerge9("text-body-light max-w-sm space-y-2", className), children: [
    /* @__PURE__ */ jsx29(Typography19, { children: title }),
    /* @__PURE__ */ jsxs26(Typography19, { variant: "body-L", children: [
      /* @__PURE__ */ jsx29("span", { children: formatDate4(open, locale, { dateStyle: "long" }) }),
      notSame && /* @__PURE__ */ jsx29("span", { children: ` - ${formatDate4(close, locale, { dateStyle: "long" })}` })
    ] })
  ] });
};
var EventDateTime_default = EventDateTime;

// src/components/events/detail/EventOrganizer.tsx
import { Link as Link7, useRouter as useRouter15, useTranslation as useTranslation19 } from "@wbk/config";
import { Button as Button14, Typography as Typography20 } from "@wbk/ui";
import { jsx as jsx30, jsxs as jsxs27 } from "react/jsx-runtime";
var EventOrganizer = ({ organizer }) => {
  const { locale } = useRouter15();
  const { t } = useTranslation19("calendar_event");
  if (!organizer)
    return null;
  const isLink = !!organizer.href;
  return /* @__PURE__ */ jsxs27("div", { className: "text-body-light space-y-2", children: [
    /* @__PURE__ */ jsx30(Typography20, { children: t("calendar_event:organizer") }),
    isLink ? /* @__PURE__ */ jsx30(
      Button14,
      {
        as: Link7,
        href: `/${locale}/organizers/${organizer.slug}`,
        className: "text-body-light p-0 text-start",
        shape: "text",
        children: /* @__PURE__ */ jsx30(Typography20, { variant: "link-L", children: organizer.title })
      }
    ) : /* @__PURE__ */ jsx30(Typography20, { variant: "body-L", children: organizer.title })
  ] });
};
var EventOrganizer_default = EventOrganizer;

// src/components/events/detail/EventDetails.tsx
import { jsx as jsx31, jsxs as jsxs28 } from "react/jsx-runtime";
var EventDetails = ({ event }) => {
  var _a;
  return /* @__PURE__ */ jsxs28("div", { className: "flex flex-col-reverse gap-6 lg:flex-row", children: [
    /* @__PURE__ */ jsxs28("div", { className: "grow space-y-6", children: [
      /* @__PURE__ */ jsxs28("div", { className: "flex flex-col-reverse space-y-8 md:flex-col", children: [
        /* @__PURE__ */ jsxs28("div", { className: "divide-body/20 flex flex-col divide-y md:flex-row md:divide-x md:divide-y-0 rtl:divide-x-reverse [&>*:first-child]:ps-0 [&>*:last-child]:pe-0 [&>*]:py-4 [&>*]:md:px-4 [&>*]:lg:basis-40", children: [
          /* @__PURE__ */ jsx31(EventDateTime_default, { schedule: event.schedule, className: "grow" }),
          /* @__PURE__ */ jsx31(AllowedAge_default, { ageRange: event.ageRange }),
          /* @__PURE__ */ jsx31(
            EventLocation_default,
            {
              location: event.location,
              className: "text-body-light [&>a]:text-body-light grow"
            }
          ),
          event.organizer && /* @__PURE__ */ jsx31(EventOrganizer_default, { organizer: event.organizer })
        ] }),
        /* @__PURE__ */ jsx31(Divider, { className: "border-body/20 hidden md:flex" }),
        /* @__PURE__ */ jsxs28("div", { className: "flex flex-col-reverse gap-4 pb-6 md:flex-row md:items-center md:pb-0", children: [
          /* @__PURE__ */ jsx31(BuyButton_default, { event, className: "max-w-md" }),
          /* @__PURE__ */ jsx31(EventStartPrice_default, { event })
        ] }),
        /* @__PURE__ */ jsx31(Divider, { className: "border-body/20 hidden md:flex" })
      ] }),
      /* @__PURE__ */ jsx31(Divider, { className: "border-body/20 !mt-0 flex md:hidden" }),
      /* @__PURE__ */ jsx31(
        CollapsableText_default,
        {
          text: event.description,
          btnProps: {
            "aria-label": `Read More About ${event.title}`,
            className: "text-body-light relative mt-2 px-0.5 py-0 text-sm underline ring-0"
          },
          markdown: typeof event.description === "string",
          className: "text-body-light"
        }
      ),
      /* @__PURE__ */ jsx31(Tags_default, { tags: (_a = event.tagsCollection) == null ? void 0 : _a.items })
    ] }),
    /* @__PURE__ */ jsx31("div", { className: "w-full shrink-0 lg:max-w-md xl:max-w-xl", children: /* @__PURE__ */ jsx31(EventGallery_default, { event }) })
  ] });
};
var EventDetails_default = EventDetails;

// src/components/events/SimilarEvents.tsx
import { useRouter as useRouter16, useTranslation as useTranslation20 } from "@wbk/config";
import { jsx as jsx32 } from "react/jsx-runtime";
var SimilarEvents = ({ event }) => {
  var _a, _b;
  const { t } = useTranslation20("calendar_event");
  const { locale } = useRouter16();
  const categorySlug = (_a = event.category) == null ? void 0 : _a.slug;
  const { data: similars } = useGetEventsList({
    lang: locale,
    limit: 5,
    where: {
      slug_not: event.slug,
      category: { slug: categorySlug }
    }
  });
  if (!((_b = similars == null ? void 0 : similars.items) == null ? void 0 : _b.length))
    return null;
  return /* @__PURE__ */ jsx32(
    EventCarousel_default,
    {
      section: {
        contentCollection: {
          items: similars.items
        },
        title: t("calendar_event:similar_events"),
        id: "similar-events",
        container: "half",
        linksCollection: {
          items: []
        }
      }
    }
  );
};
var SimilarEvents_default = SimilarEvents;

// src/pages/events/slug/index.tsx
import { Fragment as Fragment7, jsx as jsx33, jsxs as jsxs29 } from "react/jsx-runtime";
var EventDetailPage = ({ event }) => {
  var _a;
  return /* @__PURE__ */ jsxs29(Fragment7, { children: [
    /* @__PURE__ */ jsxs29("section", { className: "relative", children: [
      /* @__PURE__ */ jsx33(
        "img",
        {
          src: ((_a = event.image31) == null ? void 0 : _a.url) ? event.image31.url : event.image11.url,
          alt: "",
          className: "absolute -z-10 h-full w-full object-cover"
        }
      ),
      /* @__PURE__ */ jsx33("div", { className: "bg-primary/80 absolute inset-0 -z-10 backdrop-blur-md" }),
      /* @__PURE__ */ jsxs29("div", { className: "container space-y-4 py-8", children: [
        /* @__PURE__ */ jsx33(EventHeader_default, { event }),
        /* @__PURE__ */ jsx33(EventDetails_default, { event })
      ] })
    ] }),
    /* @__PURE__ */ jsx33(GetToLocation_default, { event }),
    /* @__PURE__ */ jsx33(SimilarEvents_default, { event })
  ] });
};
var slug_default = EventDetailPage;

// src/pages/explore/index.tsx
import { useTranslation as useTranslation21 } from "@wbk/config";
import { Typography as Typography21 } from "@wbk/ui";
import { Fragment as Fragment8, jsx as jsx34, jsxs as jsxs30 } from "react/jsx-runtime";
var ExplorePage = () => {
  const { query } = useFilterQuery_default();
  const { data, isLoading } = useGetEventsList(query);
  const { t } = useTranslation21("calendar_explore");
  return /* @__PURE__ */ jsxs30(Fragment8, { children: [
    /* @__PURE__ */ jsx34("section", { className: "bg-body text-text py-12", children: /* @__PURE__ */ jsx34("div", { className: "container", children: /* @__PURE__ */ jsx34(Typography21, { as: "h1", variant: "display-M", children: t("calendar_explore:explore_events") }) }) }),
    /* @__PURE__ */ jsxs30("section", { className: "container space-y-8 py-12", children: [
      /* @__PURE__ */ jsx34(List_default2, { showParent: true }),
      /* @__PURE__ */ jsxs30("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx34(Sort_default, { total: (data == null ? void 0 : data.total) || 0 }),
        /* @__PURE__ */ jsx34(Filters_default, { filters: ["date", "price", "organizer"] })
      ] }),
      isLoading ? /* @__PURE__ */ jsx34(EventLoading_default, {}) : (data == null ? void 0 : data.items.length) ? /* @__PURE__ */ jsxs30(Fragment8, { children: [
        /* @__PURE__ */ jsx34(EventsGrid_default, { events: data.items }),
        /* @__PURE__ */ jsx34(Pagination_default, { total: data.total })
      ] }) : /* @__PURE__ */ jsx34(Empty_default, {})
    ] })
  ] });
};
var explore_default = ExplorePage;

// src/pages/favorites/index.tsx
import { useRouter as useRouter20, useTranslation as useTranslation24 } from "@wbk/config";
import { Typography as Typography25 } from "@wbk/ui";

// src/components/favorites/Favorites.tsx
import { Fragment as Fragment9 } from "react";
import { Typography as Typography22 } from "@wbk/ui";
import { Link as Link8, useRouter as useRouter17, useTranslation as useTranslation22 } from "@wbk/config";
import { BrokenHeart } from "@wbk/svg";
import { jsx as jsx35, jsxs as jsxs31 } from "react/jsx-runtime";
var Favorites = ({ events }) => {
  const { t } = useTranslation22("calendar_common");
  const { locale } = useRouter17();
  return /* @__PURE__ */ jsxs31("section", { className: "container space-y-4 py-12", children: [
    /* @__PURE__ */ jsx35(Typography22, { as: "h2", variant: "heading-XXL", children: t("calendar_common:favorites.section_title") }),
    /* @__PURE__ */ jsx35("div", { className: "grid grid-cols-1 gap-4 sm:grid-cols-[repeat(auto-fill,minmax(312px,1fr))]", children: events.length > 0 ? events.map((event) => /* @__PURE__ */ jsxs31(Fragment9, { children: [
      /* @__PURE__ */ jsx35(Item_default, { event, className: "hidden sm:block" }),
      /* @__PURE__ */ jsx35(ListItem_default, { event, className: "sm:hidden" })
    ] }, event.id)) : /* @__PURE__ */ jsxs31("div", { className: "col-span-full flex w-full flex-col items-center justify-center gap-5 py-20 text-center", children: [
      /* @__PURE__ */ jsx35(BrokenHeart, { className: "bg-body-level-2 h-20 w-20 rounded-full p-4" }),
      /* @__PURE__ */ jsxs31("div", { className: "space-y-1", children: [
        /* @__PURE__ */ jsx35(Typography22, { as: "h3", variant: "heading-M", children: t("calendar_common:favorites.empty") }),
        /* @__PURE__ */ jsx35(Typography22, { as: "h4", variant: "label-L", color: "text-secondary", children: t("calendar_common:favorites.how_to_add_favorites_description") })
      ] }),
      /* @__PURE__ */ jsx35(ThemeButton_default, { as: Link8, href: `/${locale}/explore`, children: t("calendar_common:favorites.explore_more") })
    ] }) })
  ] });
};
var Favorites_default = Favorites;

// src/components/itinerary/Itineraries.tsx
import { useMemo as useMemo4 } from "react";
import { Button as Button16, Carousel as Carousel7, Typography as Typography24 } from "@wbk/ui";
import { Link as Link10, useRouter as useRouter19, useTranslation as useTranslation23 } from "@wbk/config";
import { AddIcon } from "@wbk/svg";

// src/components/itinerary/Item.tsx
import { Link as Link9, useRouter as useRouter18 } from "@wbk/config";
import { formatDate as formatDate5 } from "@wbk/utils";
import { Button as Button15, ImageWithPlaceholder as ImageWithPlaceholder2, Typography as Typography23 } from "@wbk/ui";
import { jsx as jsx36, jsxs as jsxs32 } from "react/jsx-runtime";
var ItineraryItem = ({ itinerary, events }) => {
  var _a;
  const { locale } = useRouter18();
  return /* @__PURE__ */ jsx36(
    Button15,
    {
      theme: "transparent",
      as: Link9,
      "data-testid": `itinerary_item_${itinerary.id}`,
      className: "group relative h-full w-full gap-0 bg-transparent p-0",
      to: `/${locale}/itinerary/view/${itinerary.id}`,
      children: /* @__PURE__ */ jsxs32("div", { className: "bg-body rounded-S flex h-full w-full flex-col items-start overflow-hidden", children: [
        /* @__PURE__ */ jsx36("div", { className: "rounded-S relative w-full overflow-hidden", children: !events.length ? /* @__PURE__ */ jsx36(ImageWithPlaceholder2, { className: "aspect-1", width: 600, height: 600 }) : events.length >= 4 ? /* @__PURE__ */ jsx36("div", { className: "grid grid-cols-2", children: events.slice(0, 4).map((event, i) => /* @__PURE__ */ jsx36(
          ContentfulMedia_default,
          {
            className: "aspect-1 h-full object-cover",
            media: event.image11,
            width: 600,
            height: 600,
            ratio: "1x1",
            fit: "thumb",
            placeholder: true
          },
          i
        )) }) : /* @__PURE__ */ jsx36(
          ContentfulMedia_default,
          {
            className: "aspect-1 h-full object-cover",
            media: events[0].image11,
            width: 600,
            height: 600,
            ratio: "1x1",
            fit: "thumb",
            placeholder: true
          }
        ) }),
        /* @__PURE__ */ jsxs32("div", { className: "p-M rounded-b-S gap-XXS bg-body-light z-10 -mt-2 flex w-full flex-1 flex-col text-start", children: [
          /* @__PURE__ */ jsx36(Typography23, { variant: "heading-S", className: "text-text line-clamp-2", children: itinerary.name }),
          itinerary.days && ((_a = itinerary.days) == null ? void 0 : _a.length) > 0 && /* @__PURE__ */ jsxs32(Typography23, { variant: "body-S", className: "text-text line-clamp-2", children: [
            formatDate5(itinerary.days[0].id, locale, {
              month: "short",
              day: "2-digit"
            }),
            /* @__PURE__ */ jsx36("span", { className: "px-2", children: "-" }),
            formatDate5(itinerary.days[itinerary.days.length - 1].id, locale, {
              month: "short",
              day: "2-digit"
            })
          ] })
        ] })
      ] })
    },
    itinerary.id
  );
};
var Item_default2 = ItineraryItem;

// src/components/itinerary/Itineraries.tsx
import { jsx as jsx37, jsxs as jsxs33 } from "react/jsx-runtime";
var Itineraries = () => {
  const { t } = useTranslation23("calendar_itinerary");
  const { locale } = useRouter19();
  const { city } = useConfig_default();
  const { itineraries } = useItinerary();
  const slugs = useMemo4(() => {
    return Array.from(
      new Set(
        itineraries.flatMap((itinerary) => {
          var _a;
          return ((_a = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a.flatMap((day) => day.events)) || [];
        })
      )
    );
  }, [itineraries]);
  const { data: events, isFetching } = useGetEventsList({
    lang: locale,
    where: { slug_in: slugs }
  });
  const eventsByItinerary = useMemo4(() => {
    var _a;
    const data = [];
    for (const itinerary of itineraries) {
      const slugs2 = ((_a = itinerary.days) == null ? void 0 : _a.flatMap((day) => day.events)) || [];
      const itineraryEvents = slugs2.length > 0 ? events == null ? void 0 : events.items.filter((event) => slugs2.includes(event.slug)) : [];
      data.push({ itinerary, events: itineraryEvents || [] });
    }
    return data;
  }, [events == null ? void 0 : events.items, itineraries]);
  return /* @__PURE__ */ jsxs33("section", { className: "container space-y-4 py-12", children: [
    /* @__PURE__ */ jsx37(Typography24, { as: "h2", variant: "heading-XXL", children: t("calendar_itinerary:section_title") }),
    isFetching ? /* @__PURE__ */ jsx37(EventLoading_default, { count: 2 }) : /* @__PURE__ */ jsxs33(
      Carousel7,
      {
        className: "p-0.5",
        arrows: "middle",
        options: { dragFree: true },
        arrowsClassName: "hidden 2xl:block",
        children: [
          /* @__PURE__ */ jsx37("div", { className: "relative min-h-full shrink-0 basis-72 sm:basis-80 ltr:mr-4 rtl:ml-4", children: /* @__PURE__ */ jsx37(
            Button16,
            {
              theme: "transparent",
              as: Link10,
              "data-testid": "create_itinerary_item",
              className: "group relative h-full w-full bg-cover bg-top bg-no-repeat p-0",
              to: `/${locale}/itinerary`,
              style: {
                backgroundImage: "url(/@wbk/calendar/images/itinerary/itinerary-button-bg.png)"
              },
              children: /* @__PURE__ */ jsxs33("div", { className: "bg-body-dark/40 hover:bg-body-dark/30 flex h-full min-h-96 w-full flex-col justify-between p-4 transition-all", children: [
                /* @__PURE__ */ jsx37(Typography24, { variant: "heading-XL", className: "text-body-light text-start", children: t("calendar_itinerary:section_button_title", { city: city.title }) }),
                /* @__PURE__ */ jsxs33(
                  Button16,
                  {
                    type: "submit",
                    theme: "action",
                    as: Link10,
                    to: `/${locale}/itinerary`,
                    className: "flex w-fit items-center gap-2",
                    children: [
                      /* @__PURE__ */ jsx37(AddIcon, { className: "h-3 w-3" }),
                      /* @__PURE__ */ jsx37(Typography24, { strong: true, children: t("calendar_itinerary:create_itinerary") })
                    ]
                  }
                )
              ] })
            }
          ) }),
          eventsByItinerary.map((itinerary) => /* @__PURE__ */ jsx37(
            "div",
            {
              className: "relative shrink-0 basis-72 sm:basis-80 ltr:mr-4 rtl:ml-4",
              children: /* @__PURE__ */ jsx37(Item_default2, { itinerary: itinerary.itinerary, events: itinerary.events })
            },
            itinerary.itinerary.id
          ))
        ]
      }
    )
  ] });
};
var Itineraries_default = Itineraries;

// src/pages/favorites/index.tsx
import { jsx as jsx38, jsxs as jsxs34 } from "react/jsx-runtime";
var FavoritePage = ({ events }) => {
  const { t } = useTranslation24("calendar_common");
  const { locale } = useRouter20();
  return /* @__PURE__ */ jsxs34(provider_default2, { children: [
    /* @__PURE__ */ jsx38("section", { className: "bg-body py-12", children: /* @__PURE__ */ jsxs34("div", { className: "container space-y-4", children: [
      /* @__PURE__ */ jsx38(
        BackButton_default,
        {
          className: "text-body-dark",
          name: t("calendar_common:home"),
          href: `/${locale}`
        }
      ),
      /* @__PURE__ */ jsx38(Typography25, { as: "h1", variant: "display-M", children: t("calendar_common:favorites.title") })
    ] }) }),
    /* @__PURE__ */ jsx38("section", { className: "bg-tertiary/20", children: /* @__PURE__ */ jsx38("div", { className: "container py-4", children: /* @__PURE__ */ jsx38(Typography25, { as: "p", variant: "body-S", className: "text-tertiary", children: t("calendar_common:favorites.storage_message") }) }) }),
    /* @__PURE__ */ jsx38(Itineraries_default, {}),
    /* @__PURE__ */ jsx38(Favorites_default, { events })
  ] });
};
var favorites_default = FavoritePage;

// src/components/itinerary/Home.tsx
import { useState as useState3 } from "react";
import { Controller, useForm } from "react-hook-form";
import { useRouter as useRouter21, useTranslation as useTranslation25 } from "@wbk/config";
import { BottomSheet, DayPicker, Divider as Divider2, Input, Popover, Typography as Typography26 } from "@wbk/ui";
import { CalendarIcon } from "@wbk/svg";
import { formatDate as formatDate6, uuid } from "@wbk/utils";
import { useDeviceDetect } from "@wbk/hooks";
import { jsx as jsx39, jsxs as jsxs35 } from "react/jsx-runtime";
var ItineraryHome = () => {
  const { locale, push } = useRouter21();
  const [open, setOpen] = useState3(false);
  const { t } = useTranslation25(["calendar_itinerary", "calendar_common"]);
  const { isMobile } = useDeviceDetect();
  const { addItinerary } = useItinerary();
  const { control, handleSubmit, watch } = useForm({
    defaultValues: { name: "", date: { from: void 0, to: void 0 } }
  });
  const { city } = useConfig_default();
  const name = watch("name");
  const date = watch("date");
  const displayValue = (date == null ? void 0 : date.from) && (date == null ? void 0 : date.to) ? `${formatDate6(date.from, locale)} - ${formatDate6(date.to, locale)}` : "";
  const onSubmit = (data) => {
    const { from, to } = data.date;
    const fromDate = new Date(from);
    const toDate = new Date(to);
    const days = [];
    const currentDate = new Date(fromDate);
    while (currentDate <= toDate) {
      days.push({
        id: new Date(currentDate),
        events: []
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }
    const itineraryId = uuid();
    addItinerary({
      id: itineraryId,
      name: data.name,
      date: data.date,
      days
    });
    push(`/${locale}/itinerary/create/${itineraryId}`);
  };
  return /* @__PURE__ */ jsxs35(
    "section",
    {
      className: "relative h-[calc(100svh-80px)] bg-cover bg-center bg-no-repeat",
      style: { backgroundImage: "url(/@wbk/calendar/images/itinerary/itinerary-bg.png)" },
      children: [
        /* @__PURE__ */ jsx39("div", { className: "bg-primary/40 absolute inset-0 h-full w-full" }),
        /* @__PURE__ */ jsx39("div", { className: "container flex h-full pt-12", children: /* @__PURE__ */ jsxs35(
          "form",
          {
            onSubmit: handleSubmit(onSubmit),
            className: "bg-body-light border-paper relative flex h-[70%] w-full max-w-xl flex-col gap-5 self-end rounded-t-xl border border-b-0 p-5 md:h-[95%] md:max-h-[700px]",
            children: [
              /* @__PURE__ */ jsxs35("div", { className: "grow space-y-5", children: [
                /* @__PURE__ */ jsx39(Typography26, { variant: "heading-L", children: t("calendar_itinerary:plan_next_trip", { city: city.title }) }),
                /* @__PURE__ */ jsx39(Divider2, {}),
                /* @__PURE__ */ jsx39(
                  Controller,
                  {
                    name: "name",
                    control,
                    rules: {
                      required: t("calendar_common:validation.required"),
                      maxLength: {
                        value: 30,
                        message: t("calendar_common:validation.max_length", { length: 30 })
                      }
                    },
                    render: ({ field: { onChange, value }, fieldState: { error } }) => /* @__PURE__ */ jsx39(
                      Input,
                      {
                        value,
                        label: t("calendar_itinerary:plan_name"),
                        id: "name",
                        error: error == null ? void 0 : error.message,
                        onChange
                      }
                    )
                  }
                ),
                /* @__PURE__ */ jsx39(
                  Controller,
                  {
                    control,
                    name: "date",
                    render: ({ field: { onChange, value } }) => {
                      return isMobile ? /* @__PURE__ */ jsx39(
                        BottomSheet,
                        {
                          ignoreHistory: true,
                          sectionClassName: "pb-28 px-5",
                          stickyFooter: ({ close }) => /* @__PURE__ */ jsxs35("div", { className: "bg-body-level-1 border-paper-level-1 flex gap-2 border-t px-6 py-4", children: [
                            /* @__PURE__ */ jsx39(
                              ThemeButton_default,
                              {
                                theme: "transparent",
                                className: "h-12 flex-1",
                                type: "button",
                                onClick: () => {
                                  onChange({
                                    from: "",
                                    to: ""
                                  });
                                  close();
                                },
                                children: t("calendar_common:clear")
                              }
                            ),
                            /* @__PURE__ */ jsx39(ThemeButton_default, { className: "h-12 flex-1", onClick: close, children: t("calendar_common:apply") })
                          ] }),
                          body: () => /* @__PURE__ */ jsx39(
                            DayPicker,
                            {
                              lang: locale,
                              mode: "range",
                              disabled: { before: /* @__PURE__ */ new Date() },
                              selected: { from: value.from, to: value.to },
                              onSelect: (range) => onChange(range),
                              weekStartsOn: 0,
                              components: {
                                CaptionLabel: ({ displayMonth }) => {
                                  return /* @__PURE__ */ jsx39("p", { className: "px-2", children: formatDate6(displayMonth, locale, {
                                    month: "long",
                                    year: "numeric"
                                  }) });
                                }
                              }
                            }
                          ),
                          render: ({ open: open2 }) => {
                            return /* @__PURE__ */ jsx39(
                              ThemeButton_default,
                              {
                                onClick: open2,
                                className: "block w-full rounded-none p-0 text-start",
                                theme: "transparent",
                                type: "button",
                                children: /* @__PURE__ */ jsx39(
                                  Input,
                                  {
                                    value: displayValue,
                                    label: t("calendar_itinerary:trip_date"),
                                    readOnly: true,
                                    className: "!w-full flex-1",
                                    endIcon: /* @__PURE__ */ jsx39(CalendarIcon, { className: "mx-2 h-full w-4" })
                                  }
                                )
                              }
                            );
                          }
                        }
                      ) : /* @__PURE__ */ jsx39(
                        Popover,
                        {
                          open,
                          onOpenChange: setOpen,
                          sideOffset: 10,
                          content: /* @__PURE__ */ jsxs35("div", { className: "space-y-2", children: [
                            /* @__PURE__ */ jsx39(
                              DayPicker,
                              {
                                lang: locale,
                                mode: "range",
                                disabled: { before: /* @__PURE__ */ new Date() },
                                selected: {
                                  from: (value == null ? void 0 : value.from) ? new Date(value.from) : void 0,
                                  to: (value == null ? void 0 : value.to) ? new Date(value.to) : void 0
                                },
                                onSelect: (range) => onChange(range),
                                weekStartsOn: 0,
                                components: {
                                  CaptionLabel: ({ displayMonth }) => {
                                    return /* @__PURE__ */ jsx39("p", { className: "px-2", children: formatDate6(displayMonth, locale, {
                                      month: "long",
                                      year: "numeric"
                                    }) });
                                  }
                                }
                              }
                            ),
                            /* @__PURE__ */ jsx39(Divider2, {}),
                            /* @__PURE__ */ jsxs35("div", { className: "flex items-center justify-between", children: [
                              /* @__PURE__ */ jsx39(
                                ThemeButton_default,
                                {
                                  theme: "transparent",
                                  shape: "text",
                                  onClick: () => {
                                    onChange({
                                      from: "",
                                      to: ""
                                    });
                                  },
                                  children: t("calendar_common:clear")
                                }
                              ),
                              /* @__PURE__ */ jsx39(ThemeButton_default, { onClick: () => setOpen(false), className: "min-w-24 p-3", children: t("calendar_common:apply") })
                            ] })
                          ] }),
                          children: /* @__PURE__ */ jsx39(
                            Input,
                            {
                              className: "text-start",
                              label: t("calendar_itinerary:trip_date"),
                              value: displayValue,
                              readOnly: true,
                              endIcon: /* @__PURE__ */ jsx39(CalendarIcon, { className: "mx-2 h-full w-4" })
                            }
                          )
                        }
                      );
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ jsx39(ThemeButton_default, { type: "submit", disabled: !name || !(date == null ? void 0 : date.from) || !(date == null ? void 0 : date.to), children: /* @__PURE__ */ jsx39(Typography26, { children: t("calendar_itinerary:start_plan") }) })
            ]
          }
        ) })
      ]
    }
  );
};
var Home_default = ItineraryHome;

// src/pages/itinerary/index.tsx
import { jsx as jsx40 } from "react/jsx-runtime";
var ItineraryPage = () => {
  return /* @__PURE__ */ jsx40(provider_default2, { children: /* @__PURE__ */ jsx40(Home_default, {}) });
};
var itinerary_default = ItineraryPage;

// src/components/itinerary/Create.tsx
import { useRef as useRef2, useState as useState7 } from "react";
import {
  APIProvider,
  AdvancedMarker,
  Map
} from "@vis.gl/react-google-maps";
import { keepPreviousData } from "@tanstack/react-query";
import { Spinner } from "@wbk/ui";
import { endOfDay, startOfDay } from "@wbk/utils";

// src/components/map/Card.tsx
import { Button as Button17, Popover as Popover2 } from "@wbk/ui";
import { twMerge as twMerge10 } from "tailwind-merge";
import { Fragment as Fragment10, jsx as jsx41, jsxs as jsxs36 } from "react/jsx-runtime";
var EventCard = (_a) => {
  var _b = _a, { event, showDetails, className, past } = _b, props = __objRest(_b, ["event", "showDetails", "className", "past"]);
  var _a2;
  return /* @__PURE__ */ jsx41(
    Popover2,
    {
      open: showDetails,
      "data-past": past,
      className: "panning_excluded w-full max-w-[85vw] data-[past=true]:grayscale [&>div]:p-0",
      content: /* @__PURE__ */ jsxs36(Fragment10, { children: [
        /* @__PURE__ */ jsx41(
          Item_default,
          {
            event,
            className: "[&_img]:aspect-1 hidden w-full max-w-72 md:block [&_img]:w-full"
          }
        ),
        /* @__PURE__ */ jsx41(ListItem_default, { event, className: "flex md:hidden" })
      ] }),
      children: /* @__PURE__ */ jsxs36(
        Button17,
        __spreadProps(__spreadValues({
          className: twMerge10(
            "panning_excluded relative w-16 overflow-hidden p-0 data-[past=true]:grayscale",
            className
          ),
          theme: "transparent",
          "data-past": past
        }, props), {
          children: [
            !!((_a2 = event.category) == null ? void 0 : _a2.icon) && /* @__PURE__ */ jsx41(
              "div",
              {
                className: "rtl:rounded-br-S ltr:rounded-bl-S absolute top-0 flex items-center justify-center p-0.5",
                style: { backgroundColor: event.category.color, insetInlineEnd: 0 },
                children: /* @__PURE__ */ jsx41(ContentfulMedia_default, { media: event.category.icon, width: 16, height: 16 })
              }
            ),
            /* @__PURE__ */ jsx41(
              ContentfulMedia_default,
              {
                media: event.image11,
                width: 400,
                height: 400,
                className: "aspect-1 w-full rounded-md object-cover",
                placeholder: true
              }
            )
          ]
        })
      )
    }
  );
};
var Card_default = EventCard;

// src/components/itinerary/SelectEvents.tsx
import { motion } from "motion/react";
import { useTranslation as useTranslation26 } from "@wbk/config";
import { Input as Input2, Typography as Typography27 } from "@wbk/ui";
import { AddIcon as AddIcon2, SearchIcon as SearchIcon3, SuccessIcon } from "@wbk/svg";

// src/components/itinerary/ItineraryEventSkeleton.tsx
import { jsx as jsx42, jsxs as jsxs37 } from "react/jsx-runtime";
var ItineraryEventSkeleton = () => {
  return /* @__PURE__ */ jsxs37("div", { className: "flex items-center gap-4", children: [
    /* @__PURE__ */ jsx42("div", { className: "bg-body-level-2 aspect-1 h-16 w-16 animate-pulse rounded-md" }),
    /* @__PURE__ */ jsx42("div", { className: "bg-body-level-2 h-10 w-full animate-pulse rounded-md" }),
    /* @__PURE__ */ jsx42("div", { className: "bg-body-level-2 aspect-1 h-10 w-10 animate-pulse rounded-md" })
  ] });
};
var ItineraryEventSkeleton_default = ItineraryEventSkeleton;

// src/components/itinerary/SelectEvents.tsx
import { Fragment as Fragment11, jsx as jsx43, jsxs as jsxs38 } from "react/jsx-runtime";
var SelectEvents = ({ events, isFetching }) => {
  const { t } = useTranslation26("calendar_itinerary");
  const { city } = useConfig_default();
  const {
    id,
    activeDay,
    setMode,
    handleSearch,
    confirmSelection,
    cancelSelection,
    toggleEventSelection,
    isEventInDay,
    selectedEvents
  } = useItinerary();
  const isEventSelected = (eventSlug) => {
    if (!activeDay || !id)
      return null;
    const isSelectedInTemp = selectedEvents.includes(eventSlug);
    const isInStorage = isEventInDay(id, activeDay, eventSlug);
    return isSelectedInTemp || isInStorage;
  };
  const handleConfirm = () => {
    if (activeDay && id) {
      confirmSelection(id, activeDay);
    }
  };
  if (!activeDay || !id)
    return null;
  return /* @__PURE__ */ jsxs38(Fragment11, { children: [
    /* @__PURE__ */ jsx43("div", { className: "bg-body-light border-paper flex w-full border-b p-5", children: /* @__PURE__ */ jsxs38(
      "form",
      {
        onSubmit: (e) => e.preventDefault(),
        className: "relative mx-auto grow overflow-hidden",
        children: [
          /* @__PURE__ */ jsx43(
            Input2,
            {
              autoComplete: "off",
              type: "search",
              name: "search",
              inputMode: "search",
              placeholder: t("calendar_common:search_in_city", { city: city.title }),
              groupClassName: "w-full",
              className: "rounded-radius py-2.5",
              onChange: (e) => handleSearch(e),
              "data-testid": "home_search_input"
            }
          ),
          /* @__PURE__ */ jsx43("div", { className: "absolute top-1/2 flex -translate-y-1/2 items-center gap-3 ltr:right-1 rtl:left-1", children: /* @__PURE__ */ jsx43(
            ThemeButton_default,
            {
              type: "button",
              "aria-label": "Search",
              className: "rounded-S items-center justify-center text-sm",
              children: t("calendar_common:search")
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ jsx43("div", { className: "h-full space-y-5 overflow-y-auto p-5", children: isFetching ? /* @__PURE__ */ jsxs38(Fragment11, { children: [
      /* @__PURE__ */ jsx43(ItineraryEventSkeleton_default, {}),
      /* @__PURE__ */ jsx43(ItineraryEventSkeleton_default, {}),
      /* @__PURE__ */ jsx43(ItineraryEventSkeleton_default, {}),
      /* @__PURE__ */ jsx43(ItineraryEventSkeleton_default, {})
    ] }) : events && events.length > 0 ? events.map((event) => /* @__PURE__ */ jsxs38(
      motion.div,
      {
        initial: { opacity: 0, scale: 0.95 },
        animate: { opacity: 1, scale: 1 },
        className: "flex items-center gap-1",
        children: [
          /* @__PURE__ */ jsxs38("div", { className: "flex grow items-center gap-2", children: [
            /* @__PURE__ */ jsx43(
              "img",
              {
                src: event.image11.url,
                width: 65,
                height: 65,
                className: "aspect-1 rounded-md object-cover",
                alt: event.slug
              }
            ),
            /* @__PURE__ */ jsx43(Typography27, { variant: "label-S", children: event.title })
          ] }),
          isEventSelected(event.slug) ? /* @__PURE__ */ jsx43(
            ThemeButton_default,
            {
              className: "aspect-1 h-8 w-8 p-1",
              shape: "text",
              onClick: () => toggleEventSelection(id, activeDay, event.slug),
              children: /* @__PURE__ */ jsx43(SuccessIcon, { className: "h-3 w-3 shrink-0" })
            }
          ) : /* @__PURE__ */ jsx43(
            ThemeButton_default,
            {
              className: "aspect-1 h-8 w-8 p-1",
              shape: "outlined",
              onClick: () => toggleEventSelection(id, activeDay, event.slug),
              children: /* @__PURE__ */ jsx43(AddIcon2, { className: "h-3 w-3 shrink-0" })
            }
          )
        ]
      },
      event.slug
    )) : /* @__PURE__ */ jsxs38("div", { className: "flex h-full flex-col items-center justify-center gap-2", children: [
      /* @__PURE__ */ jsx43("div", { className: "bg-body-level-1 mx-auto flex h-20 w-20 items-center justify-center space-y-4 rounded-full text-center", children: /* @__PURE__ */ jsx43(SearchIcon3, { className: "h-10 w-10 shrink-0" }) }),
      /* @__PURE__ */ jsx43(Typography27, { children: t("calendar_itinerary:no_events_in_area") })
    ] }) }),
    /* @__PURE__ */ jsxs38("div", { className: "bg-body-light border-paper flex w-full gap-2 border-t p-5", children: [
      /* @__PURE__ */ jsx43(
        ThemeButton_default,
        {
          onClick: () => {
            setMode("summary");
            cancelSelection();
          },
          className: "h-12 w-full",
          shape: "text",
          children: /* @__PURE__ */ jsx43(Typography27, { children: t("calendar_itinerary:cancel") })
        }
      ),
      /* @__PURE__ */ jsx43(
        ThemeButton_default,
        {
          className: "h-12 w-full",
          onClick: () => {
            setMode("summary");
            handleConfirm();
          },
          children: /* @__PURE__ */ jsx43(Typography27, { children: t("calendar_itinerary:add_to_list", {
            count: selectedEvents.length
          }) })
        }
      )
    ] })
  ] });
};
var SelectEvents_default = SelectEvents;

// src/components/itinerary/PlanSummary.tsx
import { useState as useState6 } from "react";
import { Link as Link11, useRouter as useRouter24, useTranslation as useTranslation29 } from "@wbk/config";
import { Popover as Popover4, Typography as Typography31 } from "@wbk/ui";
import { DotsIcon } from "@wbk/svg";

// src/components/itinerary/SummaryDay.tsx
import { useEffect, useRef, useState as useState4 } from "react";
import { AnimatePresence, Reorder as Reorder2 } from "motion/react";
import { useRouter as useRouter22, useTranslation as useTranslation27 } from "@wbk/config";
import { Typography as Typography29 } from "@wbk/ui";
import { AddIcon as AddIcon3 } from "@wbk/svg";
import { formatDate as formatDate7 } from "@wbk/utils";

// src/components/itinerary/EventDay.tsx
import { Reorder, motion as motion2, useDragControls } from "motion/react";
import { ImageWithPlaceholder as ImageWithPlaceholder3, Typography as Typography28 } from "@wbk/ui";
import { CloseIcon } from "@wbk/svg";
import { jsx as jsx44, jsxs as jsxs39 } from "react/jsx-runtime";
var EventDay = ({ event, onRemove, containerRef }) => {
  const controls = useDragControls();
  return /* @__PURE__ */ jsx44(
    motion2.div,
    {
      initial: { opacity: 0, scale: 0.95 },
      animate: { opacity: 1, scale: 1 },
      exit: { opacity: 0, scale: 0.85, transition: { duration: 0.15 } },
      children: /* @__PURE__ */ jsxs39(
        Reorder.Item,
        {
          value: event.slug,
          className: "bg-body-light flex items-center gap-1 rounded-md",
          dragConstraints: containerRef,
          dragElastic: 0.15,
          dragListener: false,
          dragControls: controls,
          whileDrag: {
            scale: 1.05,
            zIndex: 10,
            padding: 5
          },
          children: [
            /* @__PURE__ */ jsxs39(
              ThemeButton_default,
              {
                shape: "text",
                className: "flex h-6 w-6 cursor-grab flex-col items-center justify-center gap-[3px] p-1 ltr:mr-4 rtl:ml-4",
                onPointerDown: (e) => controls.start(e),
                children: [
                  /* @__PURE__ */ jsx44("span", { className: "bg-body-dark block h-[1.5px] w-full rounded-full" }),
                  /* @__PURE__ */ jsx44("span", { className: "bg-body-dark block h-[1.5px] w-full rounded-full" }),
                  /* @__PURE__ */ jsx44("span", { className: "bg-body-dark block h-[1.5px] w-full rounded-full" })
                ]
              }
            ),
            /* @__PURE__ */ jsxs39("div", { className: "flex grow select-none items-center gap-2", children: [
              /* @__PURE__ */ jsx44(
                ImageWithPlaceholder3,
                {
                  src: event.image11.url,
                  width: 65,
                  height: 65,
                  className: "aspect-1 rounded-md object-cover",
                  alt: event.slug
                }
              ),
              /* @__PURE__ */ jsx44(Typography28, { variant: "label-S", children: event.title })
            ] }),
            /* @__PURE__ */ jsx44(ThemeButton_default, { className: "p-2", shape: "text", onClick: () => onRemove(event.slug), children: /* @__PURE__ */ jsx44(CloseIcon, { className: "h-3 w-3 shrink-0" }) })
          ]
        },
        event.slug
      )
    }
  );
};
var EventDay_default = EventDay;

// src/components/itinerary/SummaryDay.tsx
import { jsx as jsx45, jsxs as jsxs40 } from "react/jsx-runtime";
var SummaryDay = ({ day, updateTemp, handleSaveChanges }) => {
  var _a;
  const { t } = useTranslation27("calendar_itinerary");
  const ref = useRef(null);
  const { locale } = useRouter22();
  const { getItinerary, setMode, setActiveDay, id } = useItinerary();
  const itinerary = getItinerary(id || "");
  const [eventOrder, setEventOrder] = useState4(day.events);
  const [removedEvents, setRemovedEvents] = useState4(/* @__PURE__ */ new Set());
  const { data: events, isFetching } = useGetEventsList({
    lang: locale,
    where: { slug_in: ((_a = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a.flatMap((day2) => day2.events)) || [] }
  });
  const handleReorder = (newOrder) => {
    setEventOrder(newOrder);
    updateTemp(
      day.id.toISOString(),
      newOrder.filter((slug) => !removedEvents.has(slug))
    );
  };
  const handleRemoveEvent = (slug) => {
    setRemovedEvents((prev) => {
      const updatedSet = new Set(prev);
      updatedSet.add(slug);
      return updatedSet;
    });
    setEventOrder((prev) => prev.filter((eventSlug) => eventSlug !== slug));
    updateTemp(
      day.id.toISOString(),
      eventOrder.filter((eventSlug) => eventSlug !== slug)
    );
  };
  const handleAddPlaceClick = (dayId) => {
    handleSaveChanges();
    setActiveDay(dayId);
    setMode("select-events");
  };
  useEffect(() => {
    setEventOrder(day.events);
  }, [day.events]);
  return /* @__PURE__ */ jsxs40("div", { className: "border-paper space-y-4 border-b pb-4 pt-2 last:border-0", children: [
    /* @__PURE__ */ jsxs40("div", { className: "flex min-h-8 items-center gap-2", children: [
      /* @__PURE__ */ jsx45("div", { className: "line-clamp-2 grow", children: /* @__PURE__ */ jsx45(Typography29, { variant: "heading-XXS", children: formatDate7(day.id, locale, { month: "short", day: "2-digit", year: "numeric" }) }) }),
      /* @__PURE__ */ jsx45(
        ThemeButton_default,
        {
          shape: "outlined",
          className: "rounded-[4px] px-2 py-1",
          onClick: () => handleAddPlaceClick(day.id),
          children: /* @__PURE__ */ jsxs40(Typography29, { variant: "body-S", className: "flex items-center gap-2", children: [
            /* @__PURE__ */ jsx45(AddIcon3, { className: "h-2 w-2" }),
            /* @__PURE__ */ jsx45("span", { children: t("calendar_itinerary:add_visit_place") })
          ] })
        }
      )
    ] }),
    isFetching ? /* @__PURE__ */ jsx45(ItineraryEventSkeleton_default, {}) : eventOrder.length > 0 ? /* @__PURE__ */ jsx45(
      Reorder2.Group,
      {
        ref,
        axis: "y",
        values: eventOrder,
        onReorder: handleReorder,
        className: "space-y-5",
        layoutScroll: true,
        children: /* @__PURE__ */ jsx45(AnimatePresence, { children: eventOrder.map((slug) => {
          const event = events == null ? void 0 : events.items.find((e) => e.slug === slug);
          if (!event)
            return null;
          return /* @__PURE__ */ jsx45(
            EventDay_default,
            {
              containerRef: ref,
              event,
              onRemove: handleRemoveEvent
            },
            event.id
          );
        }) })
      },
      day.id.toISOString()
    ) : /* @__PURE__ */ jsx45(Typography29, { variant: "body-S", children: t("calendar_itinerary:no_events_added_on_this_day") })
  ] });
};
var SummaryDay_default = SummaryDay;

// src/components/itinerary/EditModal.tsx
import { useState as useState5 } from "react";
import { Controller as Controller2, FormProvider, useForm as useForm2, useFormContext } from "react-hook-form";
import {
  BottomSheet as BottomSheet2,
  Button as Button18,
  DayPicker as DayPicker2,
  Divider as Divider3,
  Input as Input3,
  Modal,
  Popover as Popover3,
  Typography as Typography30
} from "@wbk/ui";
import { useDeviceDetect as useDeviceDetect2 } from "@wbk/hooks";
import { useRouter as useRouter23, useTranslation as useTranslation28 } from "@wbk/config";
import { CalendarIcon as CalendarIcon2, PenIcon } from "@wbk/svg";
import { formatDate as formatDate8 } from "@wbk/utils";
import { jsx as jsx46, jsxs as jsxs41 } from "react/jsx-runtime";
var EditModal = () => {
  const { t } = useTranslation28("calendar_itinerary");
  const { isMobile } = useDeviceDetect2();
  const { getItinerary, id } = useItinerary();
  const itinerary = getItinerary(id);
  const methods = useForm2({
    defaultValues: {
      name: (itinerary == null ? void 0 : itinerary.name) || "",
      date: itinerary == null ? void 0 : itinerary.date
    }
  });
  const render = ({ open }) => /* @__PURE__ */ jsxs41(Button18, { onClick: open, shape: "text", className: "text-text flex items-center gap-2 text-start", children: [
    /* @__PURE__ */ jsx46(PenIcon, { className: "aspect-1 h-5 w-5" }),
    /* @__PURE__ */ jsx46(Typography30, { variant: "label-L", children: t("calendar_itinerary:edit_itinerary") })
  ] });
  return /* @__PURE__ */ jsx46(FormProvider, __spreadProps(__spreadValues({}, methods), { children: isMobile ? /* @__PURE__ */ jsx46(
    BottomSheet2,
    {
      ignoreHistory: true,
      className: "bg-body pb-28",
      render,
      body: ({ close }) => /* @__PURE__ */ jsx46(Body, { close }),
      stickyFooter: ({ close }) => /* @__PURE__ */ jsx46(ActionButton, { close })
    }
  ) : /* @__PURE__ */ jsx46(
    Modal,
    {
      ignoreHistory: true,
      className: "bg-body pb-28",
      size: "xl",
      render,
      body: ({ close }) => /* @__PURE__ */ jsx46(Body, { close }),
      stickyFooter: ({ close }) => /* @__PURE__ */ jsx46(ActionButton, { close })
    }
  ) }));
};
var Body = ({ close }) => {
  const { locale } = useRouter23();
  const { isMobile } = useDeviceDetect2();
  const { t } = useTranslation28("calendar_common");
  const { getItinerary, id, updateItinerary } = useItinerary();
  const itinerary = getItinerary(id);
  const [open, setOpen] = useState5(false);
  const { control, handleSubmit, watch } = useFormContext();
  const date = watch("date");
  const displayValue = (date == null ? void 0 : date.from) && (date == null ? void 0 : date.to) ? `${formatDate8(date.from, locale)} - ${formatDate8(date.to, locale)}` : "";
  const onSubmit = (data) => {
    if (!itinerary || !id || !data.date)
      return;
    updateItinerary(id, data);
    close();
  };
  return /* @__PURE__ */ jsxs41("form", { id: "itinerary-edit-form", onSubmit: handleSubmit(onSubmit), className: "space-y-5 px-5", children: [
    /* @__PURE__ */ jsx46(Typography30, { variant: "heading-L", className: "pt-5", children: t("calendar_itinerary:edit_itinerary") }),
    /* @__PURE__ */ jsx46(
      Controller2,
      {
        name: "name",
        control,
        rules: {
          required: t("calendar_common:validation.required"),
          maxLength: {
            value: 30,
            message: t("calendar_common:validation.max_length", { length: 30 })
          }
        },
        render: ({ field, fieldState: { error } }) => /* @__PURE__ */ jsx46(Input3, __spreadProps(__spreadValues({}, field), { label: t("calendar_itinerary:plan_name"), error: error == null ? void 0 : error.message }))
      }
    ),
    /* @__PURE__ */ jsx46(
      Controller2,
      {
        control,
        name: "date",
        render: ({ field: { onChange, value } }) => {
          return isMobile ? /* @__PURE__ */ jsx46(
            BottomSheet2,
            {
              ignoreHistory: true,
              sectionClassName: "pb-28 px-5",
              stickyFooter: ({ close: close2 }) => /* @__PURE__ */ jsxs41("div", { className: "bg-body-level-1 border-paper-level-1 flex gap-2 border-t px-6 py-4", children: [
                /* @__PURE__ */ jsx46(
                  ThemeButton_default,
                  {
                    theme: "transparent",
                    className: "h-12 flex-1",
                    type: "button",
                    onClick: () => {
                      onChange({
                        from: "",
                        to: ""
                      });
                      close2();
                    },
                    children: t("calendar_common:clear")
                  }
                ),
                /* @__PURE__ */ jsx46(ThemeButton_default, { type: "submit", onClick: close2, className: "h-12 flex-1", children: t("calendar_common:apply") })
              ] }),
              body: () => /* @__PURE__ */ jsx46(
                DayPicker2,
                {
                  lang: locale,
                  mode: "range",
                  disabled: { before: /* @__PURE__ */ new Date() },
                  selected: {
                    from: (value == null ? void 0 : value.from) ? new Date(value.from) : void 0,
                    to: (value == null ? void 0 : value.to) ? new Date(value.to) : void 0
                  },
                  onSelect: (range) => onChange(range),
                  weekStartsOn: 0,
                  components: {
                    CaptionLabel: ({ displayMonth }) => {
                      return /* @__PURE__ */ jsx46("p", { className: "px-2", children: formatDate8(displayMonth, locale, {
                        month: "long",
                        year: "numeric"
                      }) });
                    }
                  }
                }
              ),
              render: ({ open: open2 }) => {
                return /* @__PURE__ */ jsx46(
                  Button18,
                  {
                    onClick: open2,
                    className: "block w-full rounded-none p-0 text-start",
                    theme: "transparent",
                    type: "button",
                    children: /* @__PURE__ */ jsx46(
                      Input3,
                      {
                        value: displayValue,
                        label: t("calendar_itinerary:trip_date"),
                        readOnly: true,
                        endIcon: /* @__PURE__ */ jsx46(CalendarIcon2, { className: "mx-2 h-full w-4" })
                      }
                    )
                  }
                );
              }
            }
          ) : /* @__PURE__ */ jsx46(
            Popover3,
            {
              open,
              onOpenChange: setOpen,
              sideOffset: 10,
              content: /* @__PURE__ */ jsxs41("div", { className: "space-y-2", children: [
                /* @__PURE__ */ jsx46(
                  DayPicker2,
                  {
                    lang: locale,
                    mode: "range",
                    disabled: { before: /* @__PURE__ */ new Date() },
                    selected: {
                      from: (value == null ? void 0 : value.from) ? new Date(value.from) : void 0,
                      to: (value == null ? void 0 : value.to) ? new Date(value.to) : void 0
                    },
                    onSelect: (range) => onChange(range),
                    weekStartsOn: 0,
                    components: {
                      CaptionLabel: ({ displayMonth }) => {
                        return /* @__PURE__ */ jsx46("p", { className: "px-2", children: formatDate8(displayMonth, locale, {
                          month: "long",
                          year: "numeric"
                        }) });
                      }
                    }
                  }
                ),
                /* @__PURE__ */ jsx46(Divider3, {}),
                /* @__PURE__ */ jsxs41("div", { className: "flex items-center justify-between", children: [
                  /* @__PURE__ */ jsx46(
                    ThemeButton_default,
                    {
                      theme: "transparent",
                      shape: "text",
                      onClick: () => {
                        onChange({
                          from: "",
                          to: ""
                        });
                      },
                      children: t("calendar_common:clear")
                    }
                  ),
                  /* @__PURE__ */ jsx46(ThemeButton_default, { onClick: () => setOpen(false), className: "min-w-24 p-3", children: t("calendar_common:apply") })
                ] })
              ] }),
              children: /* @__PURE__ */ jsx46(
                Input3,
                {
                  className: "text-start",
                  label: t("calendar_itinerary:trip_date"),
                  value: displayValue,
                  readOnly: true,
                  endIcon: /* @__PURE__ */ jsx46(CalendarIcon2, { className: "mx-2 h-full w-4" })
                }
              )
            }
          );
        }
      }
    )
  ] });
};
var ActionButton = ({ close }) => {
  const { t } = useTranslation28("calendar_common");
  const { watch } = useFormContext();
  const [isValidName, isValidDate] = watch(["name", "date"]);
  const disabled = !isValidName || !(isValidDate == null ? void 0 : isValidDate.from) || !(isValidDate == null ? void 0 : isValidDate.to);
  return /* @__PURE__ */ jsxs41("div", { className: "flex gap-2 p-5", children: [
    /* @__PURE__ */ jsx46(ThemeButton_default, { onClick: close, className: "w-full", shape: "text", children: /* @__PURE__ */ jsx46(Typography30, { strong: true, children: t("calendar_common:cancel") }) }),
    /* @__PURE__ */ jsx46(ThemeButton_default, { type: "submit", form: "itinerary-edit-form", className: "w-full", disabled, children: /* @__PURE__ */ jsx46(Typography30, { strong: true, children: t("calendar_common:save") }) })
  ] });
};
var EditModal_default = EditModal;

// src/components/itinerary/PlanSummary.tsx
import { Fragment as Fragment12, jsx as jsx47, jsxs as jsxs42 } from "react/jsx-runtime";
var PlanSummary = () => {
  var _a, _b, _c;
  const { t } = useTranslation29("calendar_itinerary");
  const { getItinerary, id, reorderEvents } = useItinerary();
  const itinerary = getItinerary(id);
  const [tempUpdates, setTempUpdates] = useState6({});
  const handleSaveChanges = () => {
    if (Object.keys(tempUpdates).length === 0)
      return;
    reorderEvents(id, tempUpdates);
    setTempUpdates({});
  };
  return /* @__PURE__ */ jsxs42(Fragment12, { children: [
    /* @__PURE__ */ jsxs42("div", { className: "border-paper flex items-center justify-between border-b p-5", children: [
      /* @__PURE__ */ jsxs42("div", { className: "flex flex-col gap-1", children: [
        /* @__PURE__ */ jsx47(Typography31, { variant: "heading-L", children: itinerary == null ? void 0 : itinerary.name }),
        /* @__PURE__ */ jsx47(Typography31, { variant: "label-L", children: t("calendar_itinerary:day_total", { count: (_a = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a.length }) })
      ] }),
      /* @__PURE__ */ jsx47(Popover4, { className: "w-full [&>div]:p-0", content: /* @__PURE__ */ jsx47(EditModal_default, {}), children: /* @__PURE__ */ jsx47(ThemeButton_default, { className: "p-1", shape: "text", children: /* @__PURE__ */ jsx47(DotsIcon, {}) }) })
    ] }),
    /* @__PURE__ */ jsxs42("div", { className: "h-full space-y-5 overflow-y-auto p-5", children: [
      ((_b = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _b.every((day) => !day.events.length)) && /* @__PURE__ */ jsx47("div", { className: "bg-tertiary/20 rounded-md p-4", children: /* @__PURE__ */ jsx47(Typography31, { variant: "label-M", children: t("calendar_itinerary:start_adding") }) }),
      (_c = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _c.map((day, index) => {
        return /* @__PURE__ */ jsx47(
          SummaryDay_default,
          {
            day,
            handleSaveChanges,
            updateTemp: (dayId, newOrder) => setTempUpdates((prev) => __spreadProps(__spreadValues({}, prev), { [dayId]: newOrder }))
          },
          index
        );
      })
    ] }),
    /* @__PURE__ */ jsx47(ActionButtons, { handleSaveChanges })
  ] });
};
var ActionButtons = ({ handleSaveChanges }) => {
  var _a, _b;
  const { t } = useTranslation29("calendar_itinerary");
  const { locale } = useRouter24();
  const { getItinerary, id } = useItinerary();
  const itinerary = getItinerary(id);
  return /* @__PURE__ */ jsxs42("div", { className: "bg-body-light border-paper flex w-full gap-2 border-t p-5", children: [
    /* @__PURE__ */ jsx47(
      ThemeButton_default,
      {
        as: Link11,
        href: `/${locale}/itinerary/download/${id}`,
        disabled: (_a = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a.every((day) => !day.events.length),
        className: "h-12 w-full",
        shape: "outlined",
        onClick: handleSaveChanges,
        children: /* @__PURE__ */ jsx47(Typography31, { children: t("calendar_itinerary:download") })
      }
    ),
    /* @__PURE__ */ jsx47(
      ThemeButton_default,
      {
        as: Link11,
        href: `/${locale}/itinerary/view/${id}`,
        disabled: (_b = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _b.every((day) => !day.events.length),
        className: "h-12 w-full",
        onClick: handleSaveChanges,
        children: /* @__PURE__ */ jsx47(Typography31, { children: t("calendar_itinerary:save_plane") })
      }
    )
  ] });
};
var PlanSummary_default = PlanSummary;

// src/components/itinerary/Create.tsx
import { jsx as jsx48, jsxs as jsxs43 } from "react/jsx-runtime";
var ItineraryCreate = () => {
  const timeoutRef = useRef2(void 0);
  const [activeEventId, setActiveEventId] = useState7();
  const [bounds, setBounds] = useState7();
  const { mode, search, activeDay } = useItinerary();
  const { query } = useFilterQuery_default({
    state: __spreadValues({
      search
    }, activeDay && {
      from: startOfDay(activeDay),
      to: endOfDay(activeDay)
    })
  });
  const { map } = useConfig_default();
  const { data: events, isFetching } = useGetEventsList(
    __spreadProps(__spreadValues({}, query), {
      where: __spreadProps(__spreadValues({}, query.where), {
        location: {
          location_within_rectangle: {
            topLeftLat: bounds == null ? void 0 : bounds.north,
            topLeftLon: bounds == null ? void 0 : bounds.west,
            bottomRightLat: bounds == null ? void 0 : bounds.south,
            bottomRightLon: bounds == null ? void 0 : bounds.east
          }
        }
      })
    }),
    { enabled: !!bounds && mode === "select-events", placeholderData: keepPreviousData }
  );
  return /* @__PURE__ */ jsx48(APIProvider, { apiKey: map.apiKey, children: /* @__PURE__ */ jsxs43("section", { className: "relative h-[calc(100svh-80px)]", children: [
    isFetching && /* @__PURE__ */ jsx48(Spinner, { className: "absolute top-6 z-50 ltr:right-5 rtl:left-5", width: 24 }),
    /* @__PURE__ */ jsx48(
      Map,
      {
        mapId: map.mapId,
        mapTypeControl: false,
        gestureHandling: "greedy",
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: true,
        disableDefaultUI: true,
        className: "h-[30%] w-full md:h-full",
        onClick: () => setActiveEventId(void 0),
        defaultCenter: map.defaultCenter,
        defaultZoom: map.defaultZoom,
        onBoundsChanged: (e) => {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = setTimeout(() => {
            setBounds(e.detail.bounds);
          }, 500);
        },
        restriction: {
          latLngBounds: map.bounds,
          strictBounds: false
        },
        children: ((events == null ? void 0 : events.items) || []).map((event) => {
          const { lat, lon } = event.location.location;
          if (!lat || !lon)
            return null;
          return /* @__PURE__ */ jsx48(
            AdvancedMarker,
            {
              onClick: () => setActiveEventId(event.id === activeEventId ? void 0 : event.id),
              position: { lat, lng: lon },
              children: /* @__PURE__ */ jsx48(Card_default, { event, showDetails: activeEventId === event.id })
            },
            event.id
          );
        })
      }
    ),
    /* @__PURE__ */ jsx48("div", { className: "absolute bottom-0 left-0 right-0 h-[70%] w-full md:h-[95%] md:max-h-[700px] md:max-w-xl ltr:md:left-20 rtl:md:right-20", children: /* @__PURE__ */ jsx48("div", { className: "bg-body-light border-paper flex h-full flex-col overflow-hidden rounded-t-xl border border-b-0", children: mode === "select-events" ? /* @__PURE__ */ jsx48(SelectEvents_default, { events: events == null ? void 0 : events.items, isFetching }) : /* @__PURE__ */ jsx48(PlanSummary_default, {}) }) })
  ] }) });
};
var Create_default = ItineraryCreate;

// src/pages/itinerary/create/index.tsx
import { jsx as jsx49 } from "react/jsx-runtime";
var ItineraryCreatePage = ({ id }) => {
  return /* @__PURE__ */ jsx49(provider_default2, { id, children: /* @__PURE__ */ jsx49(Create_default, {}) });
};
var create_default = ItineraryCreatePage;

// src/components/itinerary/Download.tsx
import { Fragment as Fragment13, useEffect as useEffect2 } from "react";
import { Divider as Divider4, Typography as Typography32 } from "@wbk/ui";
import { formatDate as formatDate9 } from "@wbk/utils";
import { useRouter as useRouter25, useTranslation as useTranslation30 } from "@wbk/config";
import { UploadIcon } from "@wbk/svg";
import { Fragment as Fragment14, jsx as jsx50, jsxs as jsxs44 } from "react/jsx-runtime";
var ItineraryDownload = () => {
  var _a, _b;
  const { t } = useTranslation30("calendar_itinerary");
  const { locale } = useRouter25();
  const { config } = useConfig_default();
  const { getItinerary, id } = useItinerary();
  const itinerary = getItinerary(id);
  const { data: events, isFetching } = useGetEventsList({
    lang: locale,
    where: { slug_in: ((_a = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a.flatMap((day) => day.events)) || [] }
  });
  useEffect2(() => {
    if (id && !!itinerary && events && events.items.length > 0) {
      const timeout = setTimeout(() => {
        window.print();
      }, 500);
      return () => clearTimeout(timeout);
    }
  }, [id, itinerary, events, events == null ? void 0 : events.items.length]);
  return /* @__PURE__ */ jsxs44(Fragment14, { children: [
    /* @__PURE__ */ jsx50("style", { children: `
      @media print {
        header, footer, nav{
          display: none !important;
        }
      }
      ` }),
    /* @__PURE__ */ jsxs44("section", { className: "container py-12", children: [
      config && /* @__PURE__ */ jsx50(
        ContentfulMedia_default,
        {
          media: config.logo,
          className: "mx-auto mb-5 hidden rounded-md object-contain p-2 print:block",
          width: 90,
          alt: config.title
        }
      ),
      /* @__PURE__ */ jsxs44("div", { className: "bg-body-light border-paper mx-auto flex h-full w-full max-w-xl flex-col overflow-hidden rounded-xl border", children: [
        /* @__PURE__ */ jsxs44("div", { className: "border-paper flex items-center justify-between border-b p-5", children: [
          /* @__PURE__ */ jsx50(Typography32, { variant: "heading-L", children: itinerary == null ? void 0 : itinerary.name }),
          /* @__PURE__ */ jsx50(
            ThemeButton_default,
            {
              className: "!p-2 print:hidden",
              theme: "action",
              onClick: () => window.print(),
              children: /* @__PURE__ */ jsx50(UploadIcon, { className: "aspect-1 h-5 w-5 rotate-180" })
            }
          )
        ] }),
        /* @__PURE__ */ jsx50("div", { className: "h-full space-y-5 overflow-y-auto p-5", children: (_b = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _b.map((day, index) => /* @__PURE__ */ jsxs44(Fragment13, { children: [
          /* @__PURE__ */ jsxs44("div", { className: "space-y-5", children: [
            /* @__PURE__ */ jsx50("div", { className: "line-clamp-2 grow", children: /* @__PURE__ */ jsx50(Typography32, { variant: "heading-XXS", children: formatDate9(day.id, locale, {
              month: "short",
              day: "2-digit",
              year: "numeric"
            }) }) }),
            isFetching ? /* @__PURE__ */ jsx50(ItineraryEventSkeleton_default, {}) : day.events.length > 0 ? day.events.map((slug) => {
              const event = events == null ? void 0 : events.items.find((e) => e.slug === slug);
              if (!event)
                return null;
              return /* @__PURE__ */ jsx50("div", { className: "flex items-center gap-1", children: /* @__PURE__ */ jsxs44("div", { className: "flex grow items-center gap-2", children: [
                /* @__PURE__ */ jsx50(
                  "img",
                  {
                    src: event.image11.url,
                    width: 65,
                    height: 65,
                    className: "aspect-1 rounded-md object-cover",
                    alt: event.slug
                  }
                ),
                /* @__PURE__ */ jsx50(Typography32, { variant: "label-S", children: event.title })
              ] }) }, event.slug);
            }) : /* @__PURE__ */ jsx50(Typography32, { variant: "body-S", children: t("calendar_itinerary:no_events_added_on_this_day") })
          ] }),
          /* @__PURE__ */ jsx50(Divider4, { className: "last:hidden" })
        ] }, index)) })
      ] })
    ] })
  ] });
};
var Download_default = ItineraryDownload;

// src/pages/itinerary/download/index.tsx
import { jsx as jsx51 } from "react/jsx-runtime";
var ItineraryDownloadPage = ({ id }) => {
  return /* @__PURE__ */ jsx51(provider_default2, { id, children: /* @__PURE__ */ jsx51(Download_default, {}) });
};
var download_default = ItineraryDownloadPage;

// src/components/itinerary/Calendar.tsx
import { useMemo as useMemo5 } from "react";
import { useRouter as useRouter27, useTranslation as useTranslation32 } from "@wbk/config";
import { breakdownDurationToUnits, dateAdd, isSameDay, splitDateTime } from "@wbk/utils";
import { Carousel as Carousel9, Typography as Typography34 } from "@wbk/ui";

// src/components/itinerary/CalendarHeader.tsx
import { Fragment as Fragment15 } from "react";
import { useRouter as useRouter26, useTranslation as useTranslation31 } from "@wbk/config";
import { twMerge as twMerge11 } from "tailwind-merge";
import { Button as Button19, Carousel as Carousel8, Divider as Divider5, Popover as Popover5, ToggleGroup as ToggleGroup2, Typography as Typography33 } from "@wbk/ui";
import { formatDate as formatDate10, scrollIntoElementId as scrollIntoElementId4 } from "@wbk/utils";
import { CalendarIcon as CalendarIcon3, DotsIcon as DotsIcon2, PenIcon as PenIcon2, TimelineIcon, UploadIcon as UploadIcon2 } from "@wbk/svg";
import { jsx as jsx52, jsxs as jsxs45 } from "react/jsx-runtime";
var ItineraryCalendarHeader = ({ mode, changeMode }) => {
  const { t } = useTranslation31("calendar_common");
  const { locale, push } = useRouter26();
  const { months, month, selectMonth, year } = useCalendarQuery_default();
  const { getItinerary, id } = useItinerary();
  const itinerary = getItinerary(id);
  const MenuItems = [
    {
      text: t("calendar_itinerary:edit_itinerary"),
      icon: /* @__PURE__ */ jsx52(PenIcon2, { className: "max-h-5 max-w-5" }),
      onClick: () => {
        push(`/${locale}/itinerary/create/${id}`);
      }
    },
    {
      text: t("calendar_itinerary:download"),
      icon: /* @__PURE__ */ jsx52(UploadIcon2, { className: "max-h-5 max-w-5 rotate-180" }),
      onClick: () => {
        push(`/${locale}/itinerary/download/${id}`);
      }
    }
  ];
  return /* @__PURE__ */ jsxs45("div", { className: "bg-body sticky top-0 z-20 py-6", children: [
    /* @__PURE__ */ jsxs45("div", { className: "container flex flex-col gap-2 md:flex-row md:items-center md:justify-between", children: [
      /* @__PURE__ */ jsxs45("div", { className: "flex flex-col gap-2", children: [
        /* @__PURE__ */ jsx52(Typography33, { variant: "heading-XXL", children: itinerary == null ? void 0 : itinerary.name }),
        /* @__PURE__ */ jsxs45("div", { className: "flex items-center justify-start gap-2", children: [
          /* @__PURE__ */ jsx52(Typography33, { variant: "label-L", color: "primary-800", children: itinerary == null ? void 0 : itinerary.date.from.toLocaleDateString() }),
          /* @__PURE__ */ jsx52(Divider5, { className: "border-primary-800 w-2" }),
          /* @__PURE__ */ jsx52(Typography33, { variant: "label-L", color: "primary-800", children: itinerary == null ? void 0 : itinerary.date.to.toLocaleDateString() })
        ] })
      ] }),
      /* @__PURE__ */ jsxs45("div", { className: "gap-M flex flex-wrap items-center justify-between md:justify-start", children: [
        /* @__PURE__ */ jsx52(
          Popover5,
          {
            className: "w-full [&>div]:p-0",
            content: /* @__PURE__ */ jsx52(Fragment15, { children: MenuItems.map((item) => /* @__PURE__ */ jsxs45(
              Button19,
              {
                onClick: item.onClick,
                shape: "text",
                className: "text-text flex w-full items-center justify-start gap-2 text-start",
                children: [
                  item.icon,
                  /* @__PURE__ */ jsx52(Typography33, { variant: "label-L", children: item.text })
                ]
              },
              item.text
            )) }),
            children: /* @__PURE__ */ jsx52(ThemeButton_default, { className: "border-primary-100 h-fit rounded-full border p-2", shape: "text", children: /* @__PURE__ */ jsx52(DotsIcon2, {}) })
          }
        ),
        /* @__PURE__ */ jsx52(
          ToggleGroup2,
          {
            type: "single",
            variant: "stacked",
            value: mode,
            onChange: (value) => {
              if (value) {
                changeMode(value);
                scrollIntoElementId4("calendar-section");
              }
            },
            options: [
              {
                icon: /* @__PURE__ */ jsx52(TimelineIcon, {}),
                text: "",
                value: "list"
              },
              {
                icon: /* @__PURE__ */ jsx52(CalendarIcon3, {}),
                text: "",
                value: "grid"
              }
            ],
            groupClassName: "!bg-body-level-2 !rounded-full",
            className: "gap-0 rounded-full",
            activeBtnProps: { shape: "solid", theme: "black", shadow: "S" },
            btnProps: {
              shape: "solid",
              theme: "black",
              className: "opacity-50 hover:opacity-100 bg-transparent"
            }
          }
        )
      ] })
    ] }),
    mode === "grid" && /* @__PURE__ */ jsx52("div", { className: "border-paper bg-body border-b pt-5", children: /* @__PURE__ */ jsx52(Carousel8, { containerClassName: "flex container justify-evenly", children: Object.keys(months).map((mo) => {
      const active = month === mo;
      const monthIndex = months[mo];
      const monthName = formatDate10(new Date(year, monthIndex), locale, { month: "long" });
      return /* @__PURE__ */ jsx52(
        Button19,
        {
          shape: "text",
          className: twMerge11(
            "text-text/50 shrink-0 overflow-visible rounded-none border-b-2 border-transparent",
            active && "text-primary border-primary"
          ),
          onClick: () => {
            selectMonth(mo);
            scrollIntoElementId4("calendar-section");
          },
          children: monthName
        },
        mo
      );
    }) }) })
  ] });
};
var CalendarHeader_default2 = ItineraryCalendarHeader;

// src/components/itinerary/Calendar.tsx
import { jsx as jsx53, jsxs as jsxs46 } from "react/jsx-runtime";
var ItineraryCalendar = () => {
  var _a, _b;
  const { search, setSearch } = useRouter27();
  const { t } = useTranslation32(["calendar_common", "calendar_event"]);
  const mode = search.get("mode") || "grid";
  const { locale } = useRouter27();
  const { getItinerary, id } = useItinerary();
  const itinerary = getItinerary(id);
  const changeMode = (newMode) => {
    if (mode === newMode)
      return;
    setSearch({ mode: newMode }, { replace: true });
  };
  const { data, isFetching } = useGetEventsList({
    lang: locale,
    where: { slug_in: ((_a = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a.flatMap((day) => day.events)) || [] }
  });
  const events = useMemo5(() => {
    var _a2;
    const itineraryEvents = {};
    for (const event of (data == null ? void 0 : data.items) || []) {
      if (!event.schedule.openDateTime || !event.schedule.closeDateTime)
        continue;
      const startDate = new Date(event.schedule.openDateTime);
      const endDate = new Date(event.schedule.closeDateTime);
      const { day } = breakdownDurationToUnits({ from: startDate, to: endDate, units: ["day"] });
      const safeDay = day || 0;
      for (let i = 0; i <= safeDay; i++) {
        const today = dateAdd({ date: startDate, interval: "day", value: i });
        if (!today)
          return;
        const dayKey = splitDateTime(today, "en", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        }).date;
        const dayInItinerary = (_a2 = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _a2.find((day2) => {
          const dayDate = new Date(day2.id);
          const formattedDayKey = splitDateTime(dayDate, "en", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          }).date;
          return formattedDayKey === dayKey && day2.events.includes(event.slug);
        });
        if (!dayInItinerary)
          continue;
        if (!itineraryEvents[dayKey])
          itineraryEvents[dayKey] = { first: [], last: [] };
        if (i === 0) {
          itineraryEvents[dayKey].first.push(event);
        } else {
          itineraryEvents[dayKey].last.push(event);
        }
      }
    }
    return itineraryEvents;
  }, [data == null ? void 0 : data.items, itinerary == null ? void 0 : itinerary.days]);
  if (!events)
    return null;
  return /* @__PURE__ */ jsxs46("section", { id: "calendar-section", className: "bg-body", children: [
    /* @__PURE__ */ jsx53(CalendarHeader_default2, { mode, changeMode }),
    mode === "grid" ? /* @__PURE__ */ jsx53(Grid_default, { events, isLoading: isFetching }) : isFetching ? /* @__PURE__ */ jsx53(MonthlyListPlaceholder_default, { showDays: false }) : /* @__PURE__ */ jsx53("div", { className: "container-1/2", children: Object.keys(events).length > 0 ? (_b = itinerary == null ? void 0 : itinerary.days) == null ? void 0 : _b.map((day) => {
      var _a2, _b2;
      const date = new Date(day.id);
      const key = splitDateTime(date, "en", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
      }).date;
      const splitdate = splitDateTime(key, locale, { month: "long", day: "2-digit" });
      const today = /* @__PURE__ */ new Date();
      const isToday = isSameDay(today, date);
      const first = ((_a2 = events[key]) == null ? void 0 : _a2.first) || [];
      const last = ((_b2 = events[key]) == null ? void 0 : _b2.last) || [];
      const dayEvents = first.concat(last);
      if (!dayEvents.length)
        return null;
      return /* @__PURE__ */ jsxs46(
        "div",
        {
          id: key,
          className: "border-paper flex scroll-mt-44 flex-col gap-4 border-b py-10 last:border-none md:flex-row md:items-center",
          children: [
            /* @__PURE__ */ jsxs46("div", { className: "container mx-0 flex w-auto min-w-44 items-baseline gap-2 md:flex-col md:items-start md:gap-0", children: [
              /* @__PURE__ */ jsx53(Typography34, { variant: "heading-XXL", children: isToday ? t("calendar_common:date.today") : splitdate.day }),
              !isToday && /* @__PURE__ */ jsx53(Typography34, { variant: "heading-XXL", children: splitdate.month }),
              /* @__PURE__ */ jsx53(Typography34, { className: "mx-1 md:mt-2", color: "text-secondary", children: t("calendar_common:events.events_total", { count: dayEvents.length }) })
            ] }),
            /* @__PURE__ */ jsx53(
              Carousel9,
              {
                rootClassName: "w-full text-center overflow-hidden",
                className: "py-0.5",
                arrows: "middle",
                children: dayEvents.map((event) => /* @__PURE__ */ jsx53(
                  "div",
                  {
                    className: "relative shrink-0 basis-72 sm:basis-80 ltr:mr-4 rtl:ml-4",
                    children: /* @__PURE__ */ jsx53(Item_default, { event })
                  },
                  event.id
                ))
              }
            )
          ]
        },
        key
      );
    }) : null })
  ] });
};
var Calendar_default = ItineraryCalendar;

// src/pages/itinerary/view/index.tsx
import { jsx as jsx54 } from "react/jsx-runtime";
var ItineraryViewPage = ({ id }) => {
  return /* @__PURE__ */ jsx54(provider_default2, { id, children: /* @__PURE__ */ jsx54(Calendar_default, {}) });
};
var view_default = ItineraryViewPage;

// src/components/map/MapView.tsx
import { useRef as useRef3, useState as useState9 } from "react";
import {
  APIProvider as APIProvider2,
  AdvancedMarker as AdvancedMarker3,
  Map as Map2
} from "@vis.gl/react-google-maps";
import { keepPreviousData as keepPreviousData2 } from "@tanstack/react-query";
import { Spinner as Spinner2 } from "@wbk/ui";

// src/components/map/GeoLocationMarker.tsx
import { useCallback, useState as useState8 } from "react";
import { AdvancedMarker as AdvancedMarker2, useMap } from "@vis.gl/react-google-maps";
import { useTranslation as useTranslation33 } from "@wbk/config";
import { Exception } from "@wbk/logger";
import { Fragment as Fragment16, jsx as jsx55, jsxs as jsxs47 } from "react/jsx-runtime";
var GeoLocationMarker = () => {
  const map = useMap();
  const { t } = useTranslation33("calendar_common");
  const [userLocation, setUserLocation] = useState8();
  const handleLocateUser = useCallback(() => __async(void 0, null, function* () {
    try {
      const position = yield new Promise((resolve, reject) => {
        if (!navigator.geolocation) {
          return reject(new Error("Geolocation not supported by browser."));
        }
        navigator.geolocation.getCurrentPosition(resolve, (error) => {
          reject(new Error(`Geolocation failed: ${error.message}`));
        });
      });
      const newLocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };
      setUserLocation(newLocation);
      if (!map)
        throw new Error("Map instance is not defined.");
      map.setCenter(newLocation);
      map.setZoom(14);
    } catch (err) {
      throw new Exception({ name: "getLocationException", error: err });
    }
  }), [map]);
  return /* @__PURE__ */ jsxs47(Fragment16, { children: [
    /* @__PURE__ */ jsx55(
      ThemeButton_default,
      {
        type: "button",
        theme: "secondary",
        className: "rounded-radius shadow-category border-category absolute bottom-5 z-50 overflow-visible border-2 ltr:left-3 rtl:right-3",
        onClick: handleLocateUser,
        children: t("calendar_common:locate_me")
      }
    ),
    userLocation && /* @__PURE__ */ jsx55(AdvancedMarker2, { position: userLocation, children: /* @__PURE__ */ jsx55("div", { className: "h-4 w-4 rounded-full border-2 border-white bg-blue-500" }) })
  ] });
};
var GeoLocationMarker_default = GeoLocationMarker;

// src/components/map/MapSearch.tsx
import { useTranslation as useTranslation34 } from "@wbk/config";
import { Input as Input4, Typography as Typography35 } from "@wbk/ui";
import { SearchIcon as SearchIcon4 } from "@wbk/svg";
import { Fragment as Fragment17, jsx as jsx56, jsxs as jsxs48 } from "react/jsx-runtime";
var MapSearch = ({ initialEvents }) => {
  const { t } = useTranslation34("calendar_common");
  const { city } = useConfig_default();
  const { events, onSearch, searchState, isLoading } = useSearch();
  return /* @__PURE__ */ jsxs48("div", { className: "bg-body-light bottom-5 hidden h-[80%] max-h-[700px] w-full max-w-md flex-col rounded-xl md:absolute md:flex ltr:right-10 rtl:left-10", children: [
    /* @__PURE__ */ jsxs48("div", { className: "gap-S p-M border-paper flex w-full flex-col", children: [
      /* @__PURE__ */ jsx56(Typography35, { variant: "heading-XS", children: t("calendar_common:all_events") }),
      /* @__PURE__ */ jsx56("div", { className: "relative mx-auto w-full grow overflow-hidden", children: /* @__PURE__ */ jsx56(
        Input4,
        {
          autoComplete: "off",
          type: "search",
          name: "search",
          inputMode: "search",
          placeholder: t("calendar_common:search_in_city", { city: city.title }),
          groupClassName: "w-full",
          className: "px-M rounded-radius",
          value: searchState,
          "data-testid": "home_search_input",
          onChange: (value) => {
            onSearch(value);
          }
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx56("div", { className: "px-M h-full space-y-5 overflow-y-auto", children: isLoading ? /* @__PURE__ */ jsx56(Fragment17, { children: /* @__PURE__ */ jsx56(ItineraryEventSkeleton_default, {}) }) : !searchState && (initialEvents == null ? void 0 : initialEvents.length) ? initialEvents.map((event) => /* @__PURE__ */ jsx56(ListItem_default, { event }, event.id)) : events && events.length > 0 ? events.map((event) => /* @__PURE__ */ jsx56(ListItem_default, { event }, event.id)) : /* @__PURE__ */ jsxs48("div", { className: "flex h-full flex-col items-center justify-center gap-2", children: [
      /* @__PURE__ */ jsx56("div", { className: "bg-body-level-1 mx-auto flex h-20 w-20 items-center justify-center space-y-4 rounded-full text-center", children: /* @__PURE__ */ jsx56(SearchIcon4, { className: "h-10 w-10 shrink-0" }) }),
      /* @__PURE__ */ jsx56(Typography35, { children: t("calendar_common:event_calendar.no_events") })
    ] }) })
  ] });
};
var MapSearch_default = MapSearch;

// src/components/map/MobileSearchCarousel.tsx
import { Carousel as Carousel10 } from "@wbk/ui";
import { jsx as jsx57 } from "react/jsx-runtime";
var MobileSearchCarousel = () => {
  const { events } = useSearch();
  if (!(events == null ? void 0 : events.length))
    return null;
  return /* @__PURE__ */ jsx57("div", { className: "container absolute bottom-20 left-0 right-0 z-50 md:hidden", children: /* @__PURE__ */ jsx57(Carousel10, { options: { dragFree: true }, className: "p-0", children: events.map((event, i) => /* @__PURE__ */ jsx57(
    ListItem_default,
    {
      event,
      className: "bg-body-light relative flex shrink-0 basis-96 ltr:mr-6 rtl:ml-6"
    },
    i
  )) }) });
};
var MobileSearchCarousel_default = MobileSearchCarousel;

// src/components/map/MapView.tsx
import { jsx as jsx58, jsxs as jsxs49 } from "react/jsx-runtime";
var MapView = (props) => {
  const timeoutRef = useRef3(void 0);
  const [activeEventId, setActiveEventId] = useState9();
  const [mapEvent, setMapEvent] = useState9();
  const { query } = useFilterQuery_default({ state: { perPage: 100 } });
  const { map } = useConfig_default();
  const zoom = (mapEvent == null ? void 0 : mapEvent.detail.zoom) || 0;
  const bounds = (mapEvent == null ? void 0 : mapEvent.detail.bounds) || map.bounds;
  const { data: events, isFetching } = useGetEventsList(
    __spreadProps(__spreadValues({}, query), {
      where: __spreadProps(__spreadValues({}, query.where), {
        tier_in: zoom <= 10 ? ["marquee"] : zoom <= 11 ? ["marquee", "tier-1"] : null,
        location: {
          location_within_rectangle: {
            topLeftLat: bounds.north,
            topLeftLon: bounds.west,
            bottomRightLat: bounds.south,
            bottomRightLon: bounds.east
          }
        }
      })
    }),
    { enabled: !!mapEvent, placeholderData: keepPreviousData2 }
  );
  return /* @__PURE__ */ jsx58(APIProvider2, { apiKey: map.apiKey, children: /* @__PURE__ */ jsxs49("div", { className: "relative h-[calc(100svh-80px)]", children: [
    isFetching && /* @__PURE__ */ jsx58(Spinner2, { className: "absolute top-6 z-50 ltr:right-5 rtl:left-5", width: 24 }),
    /* @__PURE__ */ jsxs49(
      Map2,
      __spreadProps(__spreadValues({
        mapId: map.mapId,
        mapTypeControl: false,
        gestureHandling: "greedy",
        streetViewControl: false,
        fullscreenControl: false,
        zoomControl: false,
        disableDefaultUI: true,
        clickableIcons: false,
        className: "h-full w-full",
        onClick: () => setActiveEventId(void 0),
        defaultCenter: map.defaultCenter,
        defaultZoom: map.defaultZoom,
        onBoundsChanged: (e) => {
          clearTimeout(timeoutRef.current);
          timeoutRef.current = setTimeout(() => {
            setMapEvent(e);
          }, 500);
        },
        restriction: {
          latLngBounds: map.bounds,
          strictBounds: false
        }
      }, props), {
        children: [
          /* @__PURE__ */ jsx58(GeoLocationMarker_default, {}),
          ((events == null ? void 0 : events.items) || []).map((event) => {
            const { lat, lon } = event.location.location;
            if (!lat || !lon)
              return null;
            return /* @__PURE__ */ jsx58(
              AdvancedMarker3,
              {
                onClick: () => setActiveEventId(event.id === activeEventId ? void 0 : event.id),
                position: { lat, lng: lon },
                children: /* @__PURE__ */ jsx58(Card_default, { event, showDetails: activeEventId === event.id })
              },
              event.id
            );
          })
        ]
      })
    ),
    /* @__PURE__ */ jsx58(MapSearch_default, { initialEvents: events == null ? void 0 : events.items }),
    /* @__PURE__ */ jsx58(MobileSearchCarousel_default, {})
  ] }) });
};
var MapView_default = MapView;

// src/components/map/Header.tsx
import { twMerge as twMerge12 } from "tailwind-merge";
import { Input as Input5, ToggleGroup as ToggleGroup3, Typography as Typography36 } from "@wbk/ui";
import { MapIcon, TimelineIcon as TimelineIcon2 } from "@wbk/svg";
import { useRouter as useRouter28, useTranslation as useTranslation35 } from "@wbk/config";
import { jsx as jsx59, jsxs as jsxs50 } from "react/jsx-runtime";
var MapHeader = ({ view, filters }) => {
  const { push } = useRouter28();
  const { t } = useTranslation35("calendar_common");
  const { city } = useConfig_default();
  const { onSearch, searchState } = useSearch();
  return /* @__PURE__ */ jsxs50("div", { className: "container absolute top-3 z-10 flex flex-wrap items-center gap-5", children: [
    /* @__PURE__ */ jsx59("div", { className: "basis-72 md:basis-auto", children: /* @__PURE__ */ jsx59(
      ToggleGroup3,
      {
        type: "single",
        value: view,
        onChange: (value) => {
          push(`/${value}`);
        },
        options: [
          {
            text: /* @__PURE__ */ jsx59(Typography36, { as: "span", variant: "label-M", children: t("calendar_common:map") }),
            value: "map",
            icon: /* @__PURE__ */ jsx59(MapIcon, { className: "h-6 w-6 shrink-0" })
          },
          {
            text: /* @__PURE__ */ jsx59(Typography36, { as: "span", variant: "label-M", children: t("calendar_common:timeline") }),
            value: "timeline",
            icon: /* @__PURE__ */ jsx59(TimelineIcon2, { className: "h-6 w-6 shrink-0" })
          }
        ],
        groupClassName: "h-12 p-1 bg-body-level-3",
        className: "h-full px-8",
        activeBtnProps: { theme: "action" },
        btnProps: {
          theme: "action",
          shape: "text",
          className: "text-body-dark hover:bg-body-level-2"
        },
        phill: true
      }
    ) }),
    /* @__PURE__ */ jsx59(
      "div",
      {
        className: twMerge12(
          view === "map" ? "hidden md:block" : "block",
          "[&>button>svg]:h-5 [&>button>svg]:w-5 [&>button]:h-12 [&>button]:rounded-full [&>button]:border-none"
        ),
        children: /* @__PURE__ */ jsx59(Filters_default, { filters, showLabel: false })
      }
    ),
    view === "map" && /* @__PURE__ */ jsxs50("div", { className: "relative block basis-72 md:hidden", children: [
      /* @__PURE__ */ jsx59(
        Input5,
        {
          autoComplete: "off",
          type: "search",
          name: "search",
          inputMode: "search",
          placeholder: t("calendar_common:search_in_city", { city: city.title }),
          groupClassName: "w-full",
          className: "px-M rounded-full",
          value: searchState,
          "data-testid": "home_search_input",
          onChange: (value) => {
            onSearch(value);
          }
        }
      ),
      /* @__PURE__ */ jsx59("div", { className: "absolute top-1/2 flex -translate-y-1/2 items-center gap-2 ltr:right-1 rtl:left-1 [&>button>svg]:h-4 [&>button>svg]:w-4 [&>button]:h-10 [&>button]:rounded-full [&>button]:border-none", children: /* @__PURE__ */ jsx59(Filters_default, { showLabel: false }) })
    ] })
  ] });
};
var Header_default = MapHeader;

// src/pages/map/index.tsx
import { jsx as jsx60, jsxs as jsxs51 } from "react/jsx-runtime";
var MapPage = () => {
  return /* @__PURE__ */ jsx60(provider_default, { children: /* @__PURE__ */ jsxs51("section", { className: "relative touch-none", children: [
    /* @__PURE__ */ jsx60(Header_default, { view: "map" }),
    /* @__PURE__ */ jsx60(MapView_default, {})
  ] }) });
};
var map_default = MapPage;

// src/components/map/timeline/index.tsx
import { useMemo as useMemo6, useState as useState11 } from "react";
import { TransformWrapper } from "react-zoom-pan-pinch";
import { useRouter as useRouter32, useTranslation as useTranslation36 } from "@wbk/config";
import { Typography as Typography38 } from "@wbk/ui";
import { SearchIcon as SearchIcon5 } from "@wbk/svg";

// src/components/map/timeline/Footer.tsx
import { useState as useState10 } from "react";
import { useRouter as useRouter29 } from "@wbk/config";
import { motion as motion3, useMotionValue } from "motion/react";
import { useControls, useTransformEffect, useTransformInit } from "react-zoom-pan-pinch";
import { Typography as Typography37 } from "@wbk/ui";
import { daysInMonth, formatDate as formatDate11, isSameDay as isSameDay2, isSameMonth, splitDateTime as splitDateTime2 } from "@wbk/utils";
import { jsx as jsx61, jsxs as jsxs52 } from "react/jsx-runtime";
var TimelineFooter = () => {
  const { locale, dir } = useRouter29();
  const { timelineRef, mode } = useTimeline_default();
  const [constraint, setConstraint] = useState10(0);
  const controls = useControls();
  const x = useMotionValue(controls.instance.transformState.positionX);
  const width = useMotionValue((timelineRef == null ? void 0 : timelineRef.scrollWidth) || 0);
  const dailyWidth = useMotionValue(20);
  useTransformInit((ref) => {
    var _a;
    const w = ((_a = ref.instance.contentComponent) == null ? void 0 : _a.scrollWidth) || width.get();
    const newWidth = w * ref.state.scale;
    width.set(newWidth);
    dailyWidth.set(20 * ref.state.scale);
    setConstraint(-(w - window.innerWidth));
  });
  useTransformEffect((ref) => {
    var _a;
    x.set(ref.state.positionX);
    const w = ((_a = ref.instance.contentComponent) == null ? void 0 : _a.scrollWidth) || width.get();
    const newWidth = w * ref.state.scale;
    width.set(newWidth);
    dailyWidth.set(20 * ref.state.scale);
  });
  return /* @__PURE__ */ jsxs52(
    motion3.div,
    {
      drag: "x",
      dragConstraints: {
        right: 0,
        left: constraint
      },
      dragMomentum: false,
      dragElastic: 0,
      onPointerDown: () => {
        const w = (timelineRef == null ? void 0 : timelineRef.scrollWidth) || width.get();
        const newConstraint = -(w - window.innerWidth);
        if (newConstraint !== constraint) {
          setConstraint(newConstraint);
        }
      },
      onDrag: () => {
        const newX = x.get();
        const { transformState } = controls.instance;
        controls.setTransform(newX, transformState.positionY, transformState.scale, 0);
      },
      className: "bg-body-light flex h-20 rtl:flex-row-reverse",
      style: { width, x },
      children: [
        /* @__PURE__ */ jsx61(motion3.div, { className: "min-w-5 flex-1", style: { width: dailyWidth } }),
        TIMELINE_MONTHS.map((month) => {
          const current = isSameMonth(month, /* @__PURE__ */ new Date());
          const totalDays = daysInMonth(month);
          return /* @__PURE__ */ jsxs52(
            "div",
            {
              className: "group relative flex-1 py-6",
              "data-current": current,
              "data-mode": mode,
              children: [
                /* @__PURE__ */ jsx61("div", { className: "flex border-t rtl:flex-row-reverse", children: Array.from({ length: mode === "daily" ? totalDays : MONTH_DIVISIONS }).map(
                  (_, index) => {
                    const day = new Date(month.setDate(index + 1));
                    const date = splitDateTime2(day, locale, {
                      month: "short",
                      day: "numeric"
                    });
                    const today = isSameDay2(/* @__PURE__ */ new Date(), day);
                    return /* @__PURE__ */ jsx61(
                      motion3.div,
                      {
                        className: "bg-body-dark-1 data-[today=true]:border-tertiary border-body-dark relative h-3 min-w-5 flex-1 -translate-y-1/2 data-[dir=ltr]:border-l-2 data-[dir=rtl]:border-r-2 group-data-[mode=monthly]:flex-1 data-[dir=ltr]:group-data-[mode=daily]:border-l-4 data-[dir=rtl]:group-data-[mode=daily]:border-r-4",
                        style: { width: dailyWidth },
                        "data-dir": dir,
                        "data-today": mode === "daily" && today,
                        "data-day": day.toLocaleString(),
                        children: /* @__PURE__ */ jsxs52(
                          Typography37,
                          {
                            variant: "label-XS",
                            color: mode === "daily" && today ? "tertiary" : "text-primary",
                            className: "absolute top-6 -translate-x-1/2 -rotate-90 whitespace-nowrap group-data-[mode=monthly]:hidden ltr:left-0 rtl:left-full",
                            children: [
                              date.month.slice(0, 3),
                              " ",
                              date.day
                            ]
                          }
                        )
                      },
                      index
                    );
                  }
                ) }),
                /* @__PURE__ */ jsx61("div", { className: "bg-body-dark group-data-[current=true]:bg-tertiary absolute top-4 h-4 w-4 shrink-0 -translate-x-1/2 rounded-full ltr:left-0 rtl:left-full" }),
                /* @__PURE__ */ jsx61(
                  Typography37,
                  {
                    variant: "label-L",
                    className: "absolute top-8 -translate-x-1/2 group-data-[mode=daily]:hidden ltr:left-0 rtl:left-full",
                    children: formatDate11(month, locale, { month: "long" })
                  }
                )
              ]
            },
            month.getTime()
          );
        })
      ]
    },
    timelineRef == null ? void 0 : timelineRef.scrollWidth
  );
};
var Footer_default = TimelineFooter;

// src/components/map/timeline/Controls.tsx
import { AddIcon as AddIcon4, ArrowBackIcon, MinusIcon } from "@wbk/svg";
import { Button as Button20 } from "@wbk/ui";
import { useControls as useControls2 } from "react-zoom-pan-pinch";
import { jsx as jsx62, jsxs as jsxs53 } from "react/jsx-runtime";
var TimelineControls = () => {
  const controls = useControls2();
  return /* @__PURE__ */ jsxs53("div", { className: "fixed bottom-28 right-5 flex flex-col gap-2", children: [
    /* @__PURE__ */ jsx62(
      Button20,
      {
        theme: "action",
        className: "h-12 w-12 rounded-full p-1.5 shadow-sm",
        onClick: () => controls.resetTransform(),
        children: /* @__PURE__ */ jsx62(ArrowBackIcon, { className: "h-6 w-6" })
      }
    ),
    /* @__PURE__ */ jsx62(
      Button20,
      {
        theme: "action",
        className: "h-12 w-12 rounded-full shadow-sm",
        onClick: () => controls.zoomIn(1),
        children: /* @__PURE__ */ jsx62(AddIcon4, { className: "h-6 w-6" })
      }
    ),
    /* @__PURE__ */ jsx62(
      Button20,
      {
        theme: "action",
        className: "h-12 w-12 rounded-full shadow-sm",
        onClick: () => controls.zoomOut(1),
        children: /* @__PURE__ */ jsx62(MinusIcon, { className: "h-6 w-6" })
      }
    )
  ] });
};
var Controls_default = TimelineControls;

// src/components/map/timeline/Skeleton.tsx
import { jsx as jsx63, jsxs as jsxs54 } from "react/jsx-runtime";
var TimelineSkeleton = () => {
  return /* @__PURE__ */ jsxs54("div", { className: "flex h-[calc(100svh-80px)] flex-col overflow-hidden", children: [
    /* @__PURE__ */ jsx63("div", { className: "flex h-full grow flex-nowrap", children: TIMELINE_MONTHS.map((month) => {
      return /* @__PURE__ */ jsx63("div", { className: "flex h-full w-full", children: Array.from({ length: MONTH_DIVISIONS }).map((_, index) => /* @__PURE__ */ jsx63(
        "div",
        {
          className: "border-body-level-3 odd:bg-body-level-1 even:bg-body-level-2 w-16 flex-1 animate-pulse border-l"
        },
        index
      )) }, month.toLocaleString());
    }) }),
    /* @__PURE__ */ jsx63("div", { className: "bg-body-level-1 h-20 animate-pulse" })
  ] });
};
var Skeleton_default = TimelineSkeleton;

// src/components/map/timeline/Draggable.tsx
import { TransformComponent } from "react-zoom-pan-pinch";
import { useRouter as useRouter31 } from "@wbk/config";

// src/components/map/timeline/Events.tsx
import { useRouter as useRouter30 } from "@wbk/config";
import { motion as motion4, useMotionValue as useMotionValue2 } from "motion/react";
import { useControls as useControls3, useTransformEffect as useTransformEffect2, useTransformInit as useTransformInit2 } from "react-zoom-pan-pinch";
import { daysInMonth as daysInMonth2, isSameMonth as isSameMonth2 } from "@wbk/utils";
import { jsx as jsx64, jsxs as jsxs55 } from "react/jsx-runtime";
var TimelineEvents = ({ events, date }) => {
  const { mode } = useTimeline_default();
  const isCurrentMonth = isSameMonth2(date, /* @__PURE__ */ new Date());
  const totalDays = daysInMonth2(date);
  const { dir } = useRouter30();
  const controls = useControls3();
  const scaleX = useMotionValue2(controls.instance.transformState.scale);
  useTransformInit2((ref) => {
    scaleX.set(1 / ref.state.scale);
  });
  useTransformEffect2((ref) => {
    scaleX.set(1 / ref.state.scale);
  });
  const hashKey = (event) => {
    let hash = 0;
    for (let i = 0; i < event.id.length; i++) {
      const char = event.id.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash;
    }
    const minTopPadding = 10;
    return minTopPadding + Math.abs(hash) % 15 * 8;
  };
  return /* @__PURE__ */ jsxs55(
    "div",
    {
      "data-dir": dir,
      "data-mode": mode,
      "data-current": isCurrentMonth,
      className: "group relative flex-1",
      children: [
        isCurrentMonth && /* @__PURE__ */ jsx64(
          "div",
          {
            className: "bg-tertiary absolute top-0 h-full w-0.5 group-data-[dir=ltr]:left-[var(--x)] group-data-[dir=rtl]:right-[var(--x)] group-data-[mode=daily]:w-px",
            style: { "--x": `${((/* @__PURE__ */ new Date()).getDate() - 1) / totalDays * 100}%` }
          }
        ),
        /* @__PURE__ */ jsx64("div", { className: "flex h-full w-full rtl:flex-row-reverse", children: Array.from({ length: mode === "daily" ? totalDays : MONTH_DIVISIONS }).map((_, index) => /* @__PURE__ */ jsx64(
          "div",
          {
            "data-day": index + 1,
            className: "border-body-dark/20 min-w-5 flex-1 group-data-[mode=daily]:w-2 group-data-[dir=ltr]:border-l group-data-[dir=ltr]:group-data-[mode=daily]:border-l-[0.1px] group-data-[dir=rtl]:border-r group-data-[dir=rtl]:group-data-[mode=daily]:border-r-[0.1px]"
          },
          index
        )) }),
        events.map((event) => {
          const openDate = event.schedule.openDateTime;
          const day = new Date(openDate).getDate();
          const x = day / totalDays * 100;
          const y = Math.min(hashKey(event), 90);
          const isBeforeToday = new Date(openDate) < /* @__PURE__ */ new Date();
          return /* @__PURE__ */ jsx64(
            motion4.div,
            {
              className: "absolute top-[var(--y)] z-40 group-data-[dir=ltr]:left-[var(--x)] group-data-[dir=rtl]:right-[var(--x)] group-data-[mode=daily]:group-data-[dir=ltr]:left-[var(--x-daily)] group-data-[mode=daily]:group-data-[dir=rtl]:right-[var(--x-daily)]",
              transition: { type: "tween", duration: 0 },
              style: {
                // Center the card on the x-axis
                // card half is 32px
                "--x": `calc(${x}% - 32px)`,
                // card half width is 32px + prefix width is 20px
                "--x-daily": `calc(${x}% - 52px)`,
                "--y": `${y}%`,
                scaleX
              },
              children: /* @__PURE__ */ jsx64(Card_default, { past: isBeforeToday, event })
            },
            event.id
          );
        })
      ]
    }
  );
};
var Events_default = TimelineEvents;

// src/components/map/timeline/Draggable.tsx
import { jsx as jsx65, jsxs as jsxs56 } from "react/jsx-runtime";
var TimelineDraggableArea = () => {
  const { dir } = useRouter31();
  const { events, mode } = useTimeline_default();
  return /* @__PURE__ */ jsx65(
    TransformComponent,
    {
      wrapperClass: "grow !w-full",
      contentClass: "!h-full !min-w-full overflow-hidden",
      children: /* @__PURE__ */ jsxs56("div", { className: "flex min-w-full flex-nowrap rtl:flex-row-reverse", children: [
        /* @__PURE__ */ jsx65("div", { className: "flex flex-1", children: Array.from({ length: MONTH_DIVISIONS }).map((_, index) => /* @__PURE__ */ jsx65(
          "div",
          {
            "data-dir": dir,
            "data-mode": mode,
            className: "border-body-dark/20 min-w-5 flex-1 data-[mode=daily]:w-2 data-[dir=ltr]:border-l data-[dir=ltr]:data-[mode=daily]:border-l-[0.1px] data-[dir=rtl]:border-r data-[dir=rtl]:data-[mode=daily]:border-r-[0.1px]"
          },
          index
        )) }),
        TIMELINE_MONTHS.map((date) => {
          var _a, _b;
          const key = `m${date.getFullYear()}${date.getMonth()}`;
          return /* @__PURE__ */ jsx65(Events_default, { date, events: (_b = (_a = events == null ? void 0 : events[key]) == null ? void 0 : _a.items) != null ? _b : [] }, key);
        })
      ] })
    }
  );
};
var Draggable_default = TimelineDraggableArea;

// src/components/map/timeline/index.tsx
import { jsx as jsx66, jsxs as jsxs57 } from "react/jsx-runtime";
var TimelineView = () => {
  var _a;
  const { t } = useTranslation36("calendar_common");
  const [state, setState] = useState11({
    mode: "monthly"
  });
  const { query } = useFilterQuery_default();
  const { dir } = useRouter32();
  const { data: events, isLoading } = useGetRangeEvents({
    total: TIMELINE_MONTHS.length,
    where: query.where
  });
  const initialPositionX = useMemo6(() => {
    var _a2, _b;
    if (dir === "rtl") {
      const fullWidth = (_b = (_a2 = state.timelineRef) == null ? void 0 : _a2.scrollWidth) != null ? _b : 0;
      const windowWidth = window.innerWidth;
      return windowWidth - fullWidth;
    }
    return 0;
  }, [dir, (_a = state.timelineRef) == null ? void 0 : _a.scrollWidth]);
  if (isLoading) {
    return /* @__PURE__ */ jsx66(Skeleton_default, {});
  }
  if (!events) {
    return /* @__PURE__ */ jsxs57("div", { className: "flex h-[calc(100svh-80px)] flex-col items-center justify-center space-y-6 py-4 text-center", children: [
      /* @__PURE__ */ jsx66("div", { className: "bg-body-level-2 mx-auto flex h-24 w-24 items-center justify-center space-y-4 rounded-full text-center", children: /* @__PURE__ */ jsx66(SearchIcon5, { className: "h-14 w-14 shrink-0" }) }),
      /* @__PURE__ */ jsx66("div", { className: "space-y-2", children: /* @__PURE__ */ jsx66(Typography38, { variant: "heading-L", as: "h4", children: t("calendar_common:empty_events") }) })
    ] });
  }
  return /* @__PURE__ */ jsx66(Context.Provider, { value: __spreadProps(__spreadValues({}, state), { events }), children: /* @__PURE__ */ jsx66(
    "div",
    {
      dir: "ltr",
      className: "flex h-[calc(100svh-80px)] flex-col overflow-hidden",
      children: /* @__PURE__ */ jsxs57(
        TransformWrapper,
        {
          disablePadding: true,
          initialPositionX,
          onInit: (instance) => {
            setState((prev) => __spreadProps(__spreadValues({}, prev), { timelineRef: instance.instance.contentComponent }));
          },
          panning: {
            // https://github.com/BetterTyped/react-zoom-pan-pinch/issues/408
            // velocityDisabled: true,
            excluded: ["panning_excluded"],
            lockAxisY: true
          },
          velocityAnimation: {
            sensitivity: 0
          },
          initialScale: 1,
          maxScale: 10,
          minScale: 1,
          customTransform: (x, _, scale) => {
            return `translate(${x}px) scaleX(${scale})`;
          },
          children: [
            /* @__PURE__ */ jsx66(Draggable_default, {}),
            /* @__PURE__ */ jsx66(Footer_default, {}),
            /* @__PURE__ */ jsx66(Controls_default, {})
          ]
        }
      )
    },
    dir + initialPositionX
  ) });
};
var timeline_default = TimelineView;

// src/pages/map/timeline.tsx
import { jsx as jsx67, jsxs as jsxs58 } from "react/jsx-runtime";
var TimelinePage = () => {
  return /* @__PURE__ */ jsxs58("section", { className: "relative touch-none", children: [
    /* @__PURE__ */ jsx67(Header_default, { view: "timeline", filters: ["price", "category", "organizer"] }),
    /* @__PURE__ */ jsx67(timeline_default, {})
  ] });
};
var timeline_default2 = TimelinePage;

// src/pages/organizer/index.tsx
import { Link as Link12, useRouter as useRouter33, useTranslation as useTranslation37 } from "@wbk/config";
import { Carousel as Carousel11, Typography as Typography39 } from "@wbk/ui";
import { Fragment as Fragment18, jsx as jsx68, jsxs as jsxs59 } from "react/jsx-runtime";
var OrganizerPage = ({ organizer }) => {
  var _a, _b;
  const { t } = useTranslation37(["calendar_common,calendar_explore"]);
  const { locale } = useRouter33();
  const { query } = useFilterQuery_default({
    state: { organizer: [organizer.slug] }
  });
  const { data, isLoading } = useGetEventsList(query);
  const tags = ((_a = organizer.tagsCollection) == null ? void 0 : _a.items) || [];
  return /* @__PURE__ */ jsxs59(Fragment18, { children: [
    /* @__PURE__ */ jsx68("section", { className: "bg-body text-text py-12", children: /* @__PURE__ */ jsxs59("div", { className: "container space-y-6", children: [
      /* @__PURE__ */ jsx68(BackButton_default, { name: t("calendar_common:home"), href: `/${locale}` }),
      /* @__PURE__ */ jsx68(Typography39, { as: "h1", variant: "display-M", children: organizer.title })
    ] }) }),
    /* @__PURE__ */ jsxs59("section", { className: "container space-y-8 py-12", children: [
      /* @__PURE__ */ jsx68(List_default2, { categories: ((_b = organizer.categoriesCollection) == null ? void 0 : _b.items) || [] }),
      /* @__PURE__ */ jsxs59("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx68(Sort_default, { total: (data == null ? void 0 : data.total) || 0 }),
        /* @__PURE__ */ jsx68(Filters_default, {})
      ] }),
      isLoading ? /* @__PURE__ */ jsx68(EventLoading_default, {}) : (data == null ? void 0 : data.items.length) ? /* @__PURE__ */ jsxs59(Fragment18, { children: [
        /* @__PURE__ */ jsx68(EventsGrid_default, { events: data.items }),
        /* @__PURE__ */ jsx68(Pagination_default, { total: data.total })
      ] }) : /* @__PURE__ */ jsx68(Empty_default, {}),
      !!tags.length && /* @__PURE__ */ jsx68(
        Carousel11,
        {
          rootClassName: "space-y-4 [&_div]:p-0",
          options: { dragFree: true },
          title: /* @__PURE__ */ jsx68(Typography39, { variant: "body-L", color: "text-secondary", children: t("calendar_explore:relevant_tags") }),
          children: tags.map((tag) => {
            return /* @__PURE__ */ jsx68(
              ThemeButton_default,
              {
                as: Link12,
                to: `/${locale}/tags/${tag.slug}`,
                phill: true,
                className: "bg-body-level-4 bg-body-dark/10 text-body-dark shrink-0 px-3 py-2 ltr:mr-2 rtl:ml-2",
                children: /* @__PURE__ */ jsx68(Typography39, { as: "span", children: tag.title })
              },
              tag.id
            );
          })
        }
      )
    ] })
  ] });
};
var organizer_default = OrganizerPage;

// src/pages/page/index.tsx
import { Typography as Typography40 } from "@wbk/ui";
import { Fragment as Fragment19, jsx as jsx69, jsxs as jsxs60 } from "react/jsx-runtime";
var CustomPage = ({ page }) => {
  return /* @__PURE__ */ jsxs60(Fragment19, { children: [
    /* @__PURE__ */ jsx69("section", { className: "bg-body py-12", children: /* @__PURE__ */ jsx69("div", { className: "container", children: /* @__PURE__ */ jsx69(Typography40, { as: "h1", variant: "display-M", children: page.title }) }) }),
    page.sectionsCollection.items.map((section, idx) => /* @__PURE__ */ jsx69(ContentfulSection_default, { section }, section.id + idx))
  ] });
};
var page_default = CustomPage;

// src/pages/search/index.tsx
import { useTranslation as useTranslation38 } from "@wbk/config";
import { Typography as Typography41 } from "@wbk/ui";
import { Fragment as Fragment20, jsx as jsx70, jsxs as jsxs61 } from "react/jsx-runtime";
var SearchPage = () => {
  const { state } = useFilterState();
  const { query } = useFilterQuery_default();
  const { data, isLoading } = useGetEventsList(query);
  const { t } = useTranslation38("calendar_explore");
  return /* @__PURE__ */ jsxs61(Fragment20, { children: [
    /* @__PURE__ */ jsx70("section", { className: "bg-body-light py-12", children: /* @__PURE__ */ jsx70("div", { className: "container", children: /* @__PURE__ */ jsx70(Typography41, { as: "h1", variant: "display-M", children: t("calendar_explore:search_result", { query: `"${state.search || ""}"` }) }) }) }),
    /* @__PURE__ */ jsxs61("section", { className: "container space-y-8 py-12", children: [
      /* @__PURE__ */ jsx70(List_default2, {}),
      /* @__PURE__ */ jsxs61("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx70(Sort_default, { total: (data == null ? void 0 : data.total) || 0 }),
        /* @__PURE__ */ jsx70(Filters_default, {})
      ] }),
      isLoading ? /* @__PURE__ */ jsx70(EventLoading_default, {}) : (data == null ? void 0 : data.items.length) ? /* @__PURE__ */ jsxs61(Fragment20, { children: [
        /* @__PURE__ */ jsx70(EventsGrid_default, { events: data.items }),
        /* @__PURE__ */ jsx70(Pagination_default, { total: data.total })
      ] }) : /* @__PURE__ */ jsx70(Empty_default, {})
    ] })
  ] });
};
var search_default = SearchPage;

// src/pages/tag/index.tsx
import { useRouter as useRouter34, useTranslation as useTranslation39 } from "@wbk/config";
import { Typography as Typography42 } from "@wbk/ui";
import { Fragment as Fragment21, jsx as jsx71, jsxs as jsxs62 } from "react/jsx-runtime";
var TagPage = ({ tag }) => {
  const { t } = useTranslation39("calendar_common");
  const { locale } = useRouter34();
  const { query } = useFilterQuery_default({
    state: { tag: tag.slug }
  });
  const { data, isLoading } = useGetEventsList(query);
  return /* @__PURE__ */ jsxs62(Fragment21, { children: [
    /* @__PURE__ */ jsx71("section", { className: "bg-body py-12", children: /* @__PURE__ */ jsxs62("div", { className: "container space-y-6", children: [
      /* @__PURE__ */ jsx71(BackButton_default, { name: t("calendar_common:home"), href: `/${locale}` }),
      /* @__PURE__ */ jsx71(Typography42, { as: "h1", variant: "display-M", children: t("explore:tag_title", { tag: tag.title }) })
    ] }) }),
    /* @__PURE__ */ jsxs62("section", { className: "container space-y-8 py-12", children: [
      /* @__PURE__ */ jsxs62("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx71(Sort_default, { total: (data == null ? void 0 : data.total) || 0 }),
        /* @__PURE__ */ jsx71(Filters_default, {})
      ] }),
      isLoading ? /* @__PURE__ */ jsx71(EventLoading_default, {}) : (data == null ? void 0 : data.items.length) ? /* @__PURE__ */ jsxs62(Fragment21, { children: [
        /* @__PURE__ */ jsx71(EventsGrid_default, { events: data.items }),
        /* @__PURE__ */ jsx71(Pagination_default, { total: data.total })
      ] }) : /* @__PURE__ */ jsx71(Empty_default, {})
    ] })
  ] });
};
var tag_default = TagPage;

// src/pages/weather/index.tsx
import { useRouter as useRouter35, useTranslation as useTranslation40 } from "@wbk/config";
import { Typography as Typography43 } from "@wbk/ui";
import { formatDate as formatDate12 } from "@wbk/utils";
import { Fragment as Fragment22, jsx as jsx72, jsxs as jsxs63 } from "react/jsx-runtime";
var WeatherPage = () => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const { locale } = useRouter35();
  const { city } = useConfig_default();
  const { data: weather, isLoading: weatherLoading } = useGetWeatherCondition({
    lang: locale,
    city: city.slug
  });
  const { query } = useFilterQuery_default({
    state: {
      minTemp: Math.floor(((_d = (_c = (_b = (_a = weather == null ? void 0 : weather.TemperatureSummary) == null ? void 0 : _a.Past6HourRange) == null ? void 0 : _b.Minimum) == null ? void 0 : _c.Metric) == null ? void 0 : _d.Value) || 0),
      maxTemp: Math.ceil(((_h = (_g = (_f = (_e = weather == null ? void 0 : weather.TemperatureSummary) == null ? void 0 : _e.Past6HourRange) == null ? void 0 : _f.Maximum) == null ? void 0 : _g.Metric) == null ? void 0 : _h.Value) || 0)
    }
  });
  const { data, isLoading } = useGetEventsList(query, {
    enabled: !weatherLoading
  });
  const { t } = useTranslation40("calendar_explore");
  return /* @__PURE__ */ jsxs63(Fragment22, { children: [
    /* @__PURE__ */ jsx72("section", { className: "bg-body py-12", children: /* @__PURE__ */ jsxs63("div", { className: "container flex flex-col justify-between gap-4 lg:flex-row lg:items-center", children: [
      /* @__PURE__ */ jsxs63("div", { className: "space-y-2", children: [
        /* @__PURE__ */ jsx72(Typography43, { as: "h1", variant: "display-M", children: t("calendar_explore:weather.title") }),
        /* @__PURE__ */ jsx72(Typography43, { variant: "body-L", color: "text-secondary", children: formatDate12(/* @__PURE__ */ new Date(), locale, { dateStyle: "long", timeStyle: "short" }) })
      ] }),
      /* @__PURE__ */ jsx72("div", { className: "max-w-sm", children: /* @__PURE__ */ jsx72(Info_default, { data: weather, unit: "Metric" }) })
    ] }) }),
    /* @__PURE__ */ jsxs63("section", { className: "container space-y-8 py-12", children: [
      /* @__PURE__ */ jsx72(List_default2, {}),
      /* @__PURE__ */ jsxs63("div", { className: "flex items-center justify-between", children: [
        /* @__PURE__ */ jsx72(Sort_default, { total: (data == null ? void 0 : data.total) || 0 }),
        /* @__PURE__ */ jsx72(Filters_default, {})
      ] }),
      isLoading || weatherLoading ? /* @__PURE__ */ jsx72(EventLoading_default, {}) : (data == null ? void 0 : data.items.length) ? /* @__PURE__ */ jsxs63(Fragment22, { children: [
        /* @__PURE__ */ jsx72(EventsGrid_default, { events: data.items }),
        /* @__PURE__ */ jsx72(Pagination_default, { total: data.total })
      ] }) : /* @__PURE__ */ jsx72(Empty_default, {})
    ] })
  ] });
};
var weather_default = WeatherPage;

export {
  calendar_default,
  category_default,
  slug_default,
  explore_default,
  favorites_default,
  itinerary_default,
  create_default,
  download_default,
  view_default,
  map_default,
  timeline_default2 as timeline_default,
  organizer_default,
  page_default,
  search_default,
  tag_default,
  weather_default
};
//# sourceMappingURL=chunk-J7L4GJRS.mjs.map